<template>
    <div class="sh045" id="sh045">
        <div v-if="isLoading" class="loading-container">
            <div class="vld-background" style="background: transparent;"></div>
            <div class="vld-content">
                <div class="vld-icon">
                    <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64" height="64" stroke="#000">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.8s" repeatCount="indefinite"></animateTransform>
                                </path>
                            </g>
                        </g>
                    </svg>
                </div>
                <p class="loading-message">{{ loadingMessage }}</p>
            </div>
        </div>
        <!-- 配送・ギフト設定 -->
        <h2>{{$t("sh045.labels.title")}}</h2>
        <!--エラーメッセージ表示-->
        <div class="errorMessage">
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH045_PART" class="p-3" /> 
        </div>
        
        <div class="section-inner">
            <div class="sh045-body">
                <div class="settingMainSh045">
                    <div class="settingMainSh045Row">
                                 <!-- 【注文情報設定】第一行（お届け先情報、お届け希望日時、ギフト設定）-->
                                <div class="settingMainSh045OneColumn tdkInfoCol" v-for="(oneTdkInfo, tdkInfoIndex) in sh045Init.tdkInfo" v-bind:key="tdkInfoIndex">
                                    <div class="settingMainSh045Card">
                                        <!-- お届け先情報 -->
                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                        <div class="settingMainSh045CardHeader sh045-tdk-info-header" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                            <div class="settingMainSh045CardHeaderSub sh045-tdk-info-header-sub">
                                                <div class="settingMainSh045CardHeaderSub0" v-if="sh045Init.tdkInfo && sh045Init.tdkInfo.length > 1 && sh045Init.cartSplitUseFlg != 1">{{$t('sh060.labels.orderTdkNo')}}{{tdkInfoIndex+1}}</div>
                                                <div class="settingMainSh045CardHeaderSub0" v-if="sh045Init.tdkInfo && sh045Init.tdkInfo.length > 1 && sh045Init.cartSplitUseFlg == 1">{{$t('sh060.labels.orderTdkNo')}}{{oneTdkInfo['TDK_CNT']}}</div>
                                                <div class="settingMainSh045CardHeaderSub1 sh045-tdk-info-header-title">{{$t('sh060.labels.orderTdkAddArea')}}</div>
                                            </div>
                                        </div>
                                        <!-- 店頭受取の場合 90:店頭受取 -->
                                        <div class="settingMainSh045CardHeader sh045-pickup-info-header" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'">
                                            <div class="settingMainSh045CardHeaderSub sh045-pickup-info-header-sub" style="border-bottom:0px;" >
                                                <div class="settingMainSh045CardHeaderSub0" v-if="sh045Init.tdkInfo && sh045Init.tdkInfo.length > 1 && sh045Init.cartSplitUseFlg == 1">{{$t('sh060.labels.pickupInStore')}}{{oneTdkInfo['TDK_CNT']}}</div>
                                            </div>
                                        </div>
                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                        <div class="settingMainSh045CardBody sh045-tdk-info-body" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                            <!-- 注文者住所に送る -->
                                            <template v-if="sh045Init.siteFlg == 0">
                                                <template v-if="oneTdkInfo['TDK_FLG'] === 1 && oneTdkInfo['TDK_M_SEQ'] === 0">
                                                    <h5 class="settingMainSh045CardBodyCardTitle" v-if="sh045Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg1')}}</h5>
                                                    <template v-if="sh045Init.tdkInfoDetailShowOption === 1">
                                                        <p class="settingMainSh045CardBodyCardText">{{sh045Init.kokyakuNm1}}&nbsp;{{sh045Init.kokyakuNm2}}&nbsp;{{sh045Init.kokyakuNm3}}&nbsp;様</p>
                                                        <p class="settingMainSh045CardBodyCardText">〒{{sh045Init.orderInfo['KOKYAKU_ZIP']}}</p>
                                                        <p class="settingMainSh045CardBodyCardText">
                                                            {{stringNvl(sh045Init.orderInfo['KOKYAKU_ADDR1'])}}
                                                            {{stringNvl(sh045Init.orderInfo['KOKYAKU_ADDR2'])}}
                                                            {{stringNvl(sh045Init.orderInfo['KOKYAKU_ADDR3'])}}
                                                        </p>
                                                        <p class="settingMainSh045CardBodyCardText" v-if="sh045Init.orderInfo['KOKYAKU_TEL1']">TEL：{{sh045Init.orderInfo['KOKYAKU_TEL1']}}</p>
                                                    </template>
                                                </template>
                                                <!-- 別のお届け先に送る -->
                                                <template v-else >
                                                    <h5 class="settingMainSh045CardBodyCardTitle" v-if="sh045Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg2')}}</h5>
                                                    <p class="settingMainSh045CardBodyCardText">{{oneTdkInfo['TDK_NM1']}}&nbsp;{{oneTdkInfo['TDK_NM2']}}&nbsp;{{oneTdkInfo['TDK_NM3']}}&nbsp;
                                                        <template v-if="sh045Init.tdkKeisyouPullDownFlg == 0">
                                                            様
                                                        </template>
                                                        <template v-else>
                                                            {{oneTdkInfo['TDK_TITLE']}}
                                                        </template>
                                                    </p>
                                                    <p class="settingMainSh045CardBodyCardText">〒{{oneTdkInfo['TDK_ZIP']}}</p>
                                                    <p class="settingMainSh045CardBodyCardText">
                                                        {{stringNvl(oneTdkInfo['TDK_ADDR1'])}}
                                                        {{stringNvl(oneTdkInfo['TDK_ADDR2'])}}
                                                        {{stringNvl(oneTdkInfo['TDK_ADDR3'])}}
                                                    </p>
                                                    <p class="settingMainSh045CardBodyCardText" v-if="oneTdkInfo['TDK_TEL1']">TEL：{{oneTdkInfo['TDK_TEL1']}}</p>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="oneTdkInfo['TDK_FLG'] === 1 && oneTdkInfo['TDK_M_SEQ'] === 0" >
                                                    <h5 class="settingMainSh045CardBodyCardTitle" v-if="sh045Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg1')}}</h5>
                                                    <template v-if="sh045Init.tdkInfoDetailShowOption === 1">
                                                        <p class="settingMainSh045CardBodyCardText">{{sh045Init.kokyakuNm1}}&nbsp;{{sh045Init.kokyakuNm2}}&nbsp;{{sh045Init.kokyakuNm3}}&nbsp;様</p>
                                                        <p class="settingMainSh045CardBodyCardText">〒{{sh045Init.orderInfo['KOKYAKU_ZIP']}}</p>
                                                        <p class="settingMainSh045CardBodyCardText">
                                                            {{stringNvl(sh045Init.orderInfo['KOKYAKU_ADDR1'])}}
                                                            {{stringNvl(sh045Init.orderInfo['KOKYAKU_ADDR2'])}}
                                                            {{stringNvl(sh045Init.orderInfo['KOKYAKU_ADDR3'])}}
                                                        </p>
                                                        <p class="settingMainSh045CardBodyCardText" v-if="sh045Init.orderInfo['KOKYAKU_TEL1']">TEL：{{sh045Init.orderInfo['KOKYAKU_TEL1']}}</p>
                                                    </template>
                                                </template>
                                                <!-- 別のお届け先に送る -->
                                                <template v-else >
                                                    <h5 class="settingMainSh045CardBodyCardTitle" v-if="sh045Init.catalogFlg != 1">{{$t('sh060.messages.orderTdkAddAreaMsg2')}}</h5>
                                                    <p class="settingMainSh045CardBodyCardText">{{oneTdkInfo['TDK_NM1']}}&nbsp;{{oneTdkInfo['TDK_NM2']}}&nbsp;{{oneTdkInfo['TDK_NM3']}}&nbsp;様</p>
                                                    <p class="settingMainSh045CardBodyCardText">〒{{oneTdkInfo['TDK_ZIP']}}</p>
                                                    <p class="settingMainSh045CardBodyCardText">
                                                        {{stringNvl(oneTdkInfo['TDK_ADDR1'])}}
                                                        {{stringNvl(oneTdkInfo['TDK_ADDR2'])}}
                                                        {{stringNvl(oneTdkInfo['TDK_ADDR3'])}}
                                                    </p>
                                                    <p class="settingMainSh045CardBodyCardText" v-if="oneTdkInfo['TDK_TEL1']">TEL：{{oneTdkInfo['TDK_TEL1']}}</p>
                                                </template>
                                            </template>
                                        </div>
                                        <!-- お届け商品 -->
                                        <div v-if="sh045Init.cartSplitUseFlg != 1 && sh045Init.tdkInfo && sh045Init.tdkInfo.length > 1">
                                            <div class="settingMainSh045CardHeader sh045-item-section-header">
                                                <div class="settingMainSh045CardHeaderSub sh045-item-section-header-sub">
                                                    <div class="settingMainSh045CardHeaderSub1 sh045-item-section-title">{{$t('sh060.labels.orderItemArea')}}</div>
                                                </div>
                                            </div>
                                            <div class="settingMainSh045CardBody sh045-item-section-body">
                                                <div class="itemTable" id="cartInfo">
                                                    <div class="itemHeader">
                                                        <!--No.-->
                                                        <div class="label divNo">
                                                            <label class="no">{{$t('common.labels.no')}}</label>
                                                        </div>
                                                        <!--商品名-->
                                                        <div class="label divItemNm">
                                                            <label class="itemNm">{{$t('common.labels.productName')}}</label>
                                                        </div>
                                                        <!--単価-->
                                                        <div class="label divPrice" v-if="sh045Init.priceShow != 1">
                                                            <label class="unitPrice">{{$t('common.labels.unitPrice')}}</label>
                                                        </div>
                                                        <!--数量-->
                                                        <div class="label divQty">
                                                            <label class="quantity">{{$t('common.labels.quantity')}}</label>
                                                        </div>
                                                        <!--金額-->
                                                        <div class="label divTax" v-if="sh045Init.priceShow != 1">
                                                            <label class="tax">
                                                                {{$t('common.labels.kingakuStr')}}
                                                                <!--税込-->
                                                                <span class="price-tax" v-if="sh045Init.orderInfo['TNK_DSP_KBN'] == '1'">{{$t('common.labels.taxincluded')}}</span>
                                                                <!--税抜-->
                                                                <span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                                            </label>
                                                        </div>
                                                        <!--販売数-->
                                                        <div class="label productZaikoConf" v-if="oneTdkInfo['HANBAI_SUU_FLG'] == 1 && sh045Init.hanbaiSuuBtnShowOption == 1"></div>
                                                    </div>
                                                    <div class="itemBody">
                                                        <div v-for="(oneTdkItemInfo, tdkItemIndex) in oneTdkInfo['TDK_ITEM_LIST']" :key="tdkItemIndex" class="itemList">
                                                            <!--No.-->
                                                            <div class="label divNo" :aria-label="$t('common.labels.no')">
                                                                <div style="display:flex;align-items:center;gap: 6px;">
                                                                    <img v-if="sh045Init.itemImageShowOption == 1 && stringNvl(oneTdkItemInfo['IMG_URL1'],'') != ''" :src="oneTdkItemInfo['IMG_URL1']" :alt="stringNvl(oneTdkItemInfo['WEB_ITEM_NM'],'')" @error="getErrImage" class="item-image sh045-item-img">
                                                                    <span>{{tdkItemIndex + 1}}</span>
                                                                </div>
                                                            </div>
                                                            <!--商品名-->
                                                            <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                                                                <span class="cartOndo" v-if="stringNvl(oneTdkItemInfo['ONDO_NM'],'') != ''">【{{stringNvl(oneTdkItemInfo['ONDO_NM'],'')}}】</span>
                                                                {{stringNvl(oneTdkItemInfo['WEB_ITEM_NM'],'')}}
                                                            </div>
                                                            <!--単価-->
                                                            <div class="label divPrice" v-if="sh045Init.priceShow != 1" :aria-label="$t('common.labels.unitPrice')">
                                                                <!--税込-->
                                                                <span v-if="sh045Init.orderInfo['TNK_DSP_KBN'] == '1'">{{formatPrice(oneTdkItemInfo['DISP_TNK_IN_ZEI'])}}円</span>
                                                                <!--税抜-->
                                                                <span v-else>{{formatPrice(oneTdkItemInfo['DISP_TNK'])}}円</span>
                                                            </div>
                                                            <!--数量-->
                                                            <div class="label divQty" :aria-label="$t('common.labels.quantity')">
                                                                {{formatPrice(oneTdkItemInfo['QTY'])}}
                                                            </div>
                                                            <!--金額-->
                                                            <div class="label divTax" v-if="sh045Init.priceShow != 1" :aria-label="$t('common.labels.kingakuStr')">
                                                                <!--税込-->
                                                                <span class="price" v-if="sh045Init.orderInfo['TNK_DSP_KBN'] == '1'">{{formatPrice(oneTdkItemInfo['SHOUKEI_IN_ZEI'])}}円</span>
                                                                <!--税抜-->
                                                                <span class="price" v-else>{{formatPrice(oneTdkItemInfo['SHOUKEI'])}}円</span>
                                                            </div>
                                                            <!--販売数-->
                                                            <div class="label productZaikoConf" v-if="oneTdkInfo['HANBAI_SUU_FLG'] == 1 && sh045Init.hanbaiSuuBtnShowOption == 1">
                                                                <span class="hanbaiQtyInfo" v-if="oneTdkItemInfo['HANBAI_QTY_DISPLAY'] && oneTdkItemInfo['HANBAI_QTY_DISPLAY'] === 1">
                                                                    <a href="#" @click.prevent="showModal(oneTdkItemInfo['ITEM_CD'], oneTdkItemInfo['ITEM_NM1'])">{{$t('common.labels.productZaikoConf')}}</a>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- お届け希望日時 -->
                                        <template v-if="sh045Init.cartSplitUseFlg != 1 && (sh045Init.tdkkibouFlg == 1 || sh045Init.tdkTimeFlg == 1)">
                                            <div class="settingMainSh045CardHeader sh045-datetime-section-header">
                                                <div class="settingMainSh045CardHeaderSub sh045-datetime-section-header-sub">
                                                    <div class="settingMainSh045CardHeaderSub1 sh045-datetime-section-title">{{$t('sh060.labels.orderTdkDateArea')}}</div>
                                                </div>
                                            </div>
                                            <div class="settingMainSh045CardBody sh045-datetime-section-body">
                                                <table class="sh045-body-order-tbl-person sh045-body-order-tbl-mb32">
                                                    <!-- お届け希望日 -->
                                                    <tr :id="'tdkYmdScroll_' + oneTdkInfo['TDK_SEQ']" v-if="sh045Init.tdkkibouFlg == 1">
                                                        <th>{{$t("sh045.labels.deliveryDates")}}</th>
                                                        <td class="td-res-height">
                                                            <!-- 指定なし -->
                                                            <input class="sh045-rdo-hope-day" :id="'radioGroup1_tdk_' + tdkInfoIndex + '_1'" type="radio"
                                                                :name="'radioGroup1_tdk_' + tdkInfoIndex" :value="1"
                                                                :disabled="oneTdkInfo['TDK_YMD_HISSU_FLG'] == 1 || oneTdkInfo['HANBAI_SUU_FLG'] == 1"
                                                                v-model="oneTdkInfo.radioGroup1" @click="hopeDayRadio(1, tdkInfoIndex)"/>
                                                            <label :for="'radioGroup1_tdk_' + tdkInfoIndex + '_1'" style="margin:0 8px;">：{{$t("sh045.labels.unspecified")}}</label>
                                                            <br>
                                                            <!-- 指定あり -->
                                                            <input class="sh045-rdo-hope-day" :id="'radioGroup1_tdk_' + tdkInfoIndex + '_2'" type="radio"
                                                                :name="'radioGroup1_tdk_' + tdkInfoIndex" :value="2"
                                                                :disabled="oneTdkInfo['TDK_YMD_ERR_FLG'] == 1"
                                                                v-model="oneTdkInfo.radioGroup1" @click="hopeDayRadio(2, tdkInfoIndex)"/>
                                                            <label :for="'radioGroup1_tdk_' + tdkInfoIndex + '_2'" style="margin:0 8px;">：{{$t("sh045.labels.specified")}}</label>
                                                            <br>
                                                            <select class="sh045-sel-hope-day" v-model="oneTdkInfo.hopeTdkYmd"
                                                                :id="'sh045_hopeTdkYmd_' + tdkInfoIndex"
                                                                :disabled="oneTdkInfo.radioGroup1 != 2"
                                                                @change="hopeDayChange(oneTdkInfo, tdkInfoIndex)">
                                                                <option v-for="day in oneTdkInfo.tdkYmdList" :value="day.KEY" :key="day.KEY">{{day.VALUE}}</option>
                                                            </select>
                                                            <!-- 販売数設定時：出荷予定日・在庫警告 -->
                                                            <template v-if="oneTdkInfo['HANBAI_SUU_FLG'] == 1">
                                                                <span class="sh045-txt-shukka-yoteibi" v-if="oneTdkInfo.shukkaYoteibi">出荷予定日：{{oneTdkInfo.shukkaYoteibi}}</span>
                                                                <div class="sh045-txt-zaiko-warn" v-if="oneTdkInfo.messages && oneTdkInfo.messages.length">
                                                                    <div class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</div>
                                                                    <div class="error-message-warn">
                                                                        <span v-for="error in oneTdkInfo.messages" :key="error">・{{ error }}<br></span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <div v-html="descriptionInfo[1]"></div>
                                                        </td>
                                                    </tr>
                                                    <!-- お届け希望時間 -->
                                                    <tr v-if="sh045Init.tdkTimeFlg == 1">
                                                        <th>{{$t('sh045.labels.deliveryTime')}}</th>
                                                        <td>
                                                            <select class="sh045-sel-hope-time" v-model="oneTdkInfo.hopeTdkTimeKbn"
                                                                :id="'sh045_hopeTdkTimeKbn_' + tdkInfoIndex">
                                                                <option v-for="time in oneTdkInfo.hopeTimeList" :value="time.KEY" :key="time.KEY">{{time.VALUE}}</option>
                                                            </select>
                                                            <div v-html="descriptionInfo[2]"></div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </template>
                                        <!-- ギフト設定（非カート分割時：届先ごと） -->
                                        <template v-if="sh045Init.cartSplitUseFlg != 1 && giftSectionVisible">
                                            <div class="settingMainSh045CardHeader sh045-gift-section-header">
                                                <div class="settingMainSh045CardHeaderSub sh045-gift-section-header-sub">
                                                    <div class="settingMainSh045CardHeaderSub1 sh045-gift-section-title">{{$t('sh060.labels.giftSetArea')}}</div>
                                                </div>
                                            </div>
                                            <div class="settingMainSh045CardBody sh045-gift-section-body">
                                                <table class="sh045-body-order-tbl-person sh045-body-order-tbl-mb32" :id="'sh045_table_giftSetting_' + tdkInfoIndex">
                                                    <!-- のし -->
                                                    <tr :id="'tdkGiftScroll_' + oneTdkInfo['TDK_SEQ']" v-if="sh045Init.nosiFlg == 1">
                                                        <th>
                                                            {{$t("sh030.labels.works")}}
                                                        </th>
                                                        <td>
                                                            <select class="sh045-sel-noshi" :id="'sagyoKanriKomokuCd_' + tdkInfoIndex" v-model="oneTdkInfo.sagyoKanriKomokuCd">
                                                                <option value=""></option>
                                                                <option v-for="noshi in sh045Init.noshiList" :key="noshi.KEY" :value="noshi.KEY">{{noshi.VALUE}}</option>
                                                            </select>
                                                            <div v-html="descriptionInfo[7]"></div>
                                                        </td>
                                                    </tr>
                                                    <!-- 包装紙 -->
                                                    <tr v-if="sh045Init.housoushiFlg == 1">
                                                        <th>
                                                            {{$t("sh030.labels.wrappingPaper")}}
                                                        </th>
                                                        <td>
                                                            <select class="sh045-sel-housoushi" :id="'sagyoKanriKomokuCd2_' + tdkInfoIndex" v-model="oneTdkInfo.sagyoKanriKomokuCd2">
                                                                <option value=""></option>
                                                                <option v-for="housoushi in sh045Init.housoushiList" :key="housoushi.KEY" :value="housoushi.KEY">{{housoushi.VALUE}}</option>
                                                            </select>
                                                            <div v-html="descriptionInfo[8]"></div>
                                                        </td>
                                                    </tr>
                                                    <!-- 送り主名 -->
                                                    <tr v-if="sh045Init.noshiNaireFlg == 1">
                                                        <th>
                                                            {{$t("sh030.labels.senderName")}}
                                                        </th>
                                                        <td>
                                                            <!-- 送り主名1 -->
                                                            {{$t("common.labels.okurinushi1Label")}}&nbsp;
                                                            <input-check :id="'noshiNaire1_' + tdkInfoIndex" :name="'noshiNaire1_' + tdkInfoIndex"
                                                                class="sh045-inp-okurinushi" type="text" v-model="oneTdkInfo.noshiNaire1"/>
                                                            <br>
                                                            <!-- 送り主名2 -->
                                                            {{$t("common.labels.okurinushi2Label")}}&nbsp;
                                                            <input-check :id="'noshiNaire2_' + tdkInfoIndex"
                                                                class="sh045-inp-okurinushi" type="text" v-model="oneTdkInfo.noshiNaire2"/>
                                                            <div v-html="descriptionInfo[9]"></div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </template>
                                        <!-- カート分割対応 配送単位表示 -->
                                        <div :class="'settingMainSh045CardHeaderSub1 head'+ haisouInfoIndex" v-for="(oneHaisouInfo, haisouInfoIndex) in oneTdkInfo['TDK_HAISOU_LIST'] " v-bind:key="haisouInfoIndex" 
                                                    style="margin-top:0px!important;margin-bottom:0px!important;flex-basis:0px!important;">
                                            <!-- 購入する商品のみ表示対応 -->
                                            <div :class="'settingMainSh045CardHeader item' + haisouInfoIndex" v-if="sh045Init.cartSplitUseFlg == 1 && stringNvl(oneHaisouInfo['QTY_NOTZERO_COUNT_FLG']) == '1'">
                                                <!-- 店頭受取以外の場合 90:店頭受取 -->
                                                <div :class="'settingMainSh045CardHeaderSub sub' + haisouInfoIndex" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'">
                                                    <div :class="'settingMainSh045CardHeaderSub1 ship' + haisouInfoIndex">
                                                        {{$t('sh060.labels.shippingNo')}}{{haisouInfoIndex+1}}
                                                        {{$t('sh060.labels.leftKakko')}}
                                                        {{oneHaisouInfo['TDK_ITEM_LIST'][0]['ONDO_NM']}}
                                                        {{$t('sh060.labels.rightKakko')}}
                                                    </div>
                                                </div>
                                                <!-- 店頭受取の場合 90:店頭受取 -->
                                                <div :class="'settingMainSh045CardHeaderSub sub' + haisouInfoIndex" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'">
                                                    <div :class="'settingMainSh045CardHeaderSub1 ship' + haisouInfoIndex" v-if="sh045Init.tdkInfo && sh045Init.tdkInfo.length>1">
                                                        {{$t('sh060.labels.pickup')}}{{haisouInfoIndex+1}}
                                                    </div>
                                                    <div :class="'settingMainSh045CardHeaderSub1 ship' + haisouInfoIndex" v-else>
                                                        {{$t('sh060.labels.pickupInStore')}}{{haisouInfoIndex+1}}
                                                    </div>
                                                </div>
                                               <div :class="'settingMainSh045CardBody sh045-inline-item-body body' + haisouInfoIndex">
                                                    <table class="sh045-body-order-tbl-person sh045-body-order-tbl-mb32">
                                                        <thead>
                                                            <tr>
                                                                <!--商品CD-->
                                                                <th class="w200">{{$t('common.labels.productCode')}}</th>
                                                                <!--商品名-->
                                                                <th>{{$t('common.labels.productName')}}</th>
                                                                <!--単価-->
                                                                <th class="w160" v-if="sh045Init.priceShow != 1">{{$t('common.labels.unitPrice')}}</th>
                                                                <!--数量-->
                                                                <th class="w80">{{$t('common.labels.quantity')}}</th>
                                                                <!--金額-->
                                                                <th class="w160" v-if="sh045Init.priceShow != 1">{{$t('common.labels.kingakuStr')}}
                                                                    <!--税込-->
                                                                    <span class="price-tax" v-if="sh045Init.orderInfo['TNK_DSP_KBN'] == '1'">{{$t('common.labels.taxincluded')}}</span>
                                                                    <!--税抜-->
                                                                    <span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                                                </th>
                                                                <!--同梱品-->
                                                                <th v-if="sh045Init.doukonHinOption == 1">{{sh045Init.doukonHinLabel}}</th>
                                                                <!--販売数-->
                                                                <th class="hanbaiSuuCell" v-if="oneHaisouInfo['HANBAI_SUU_FLG'] == 1 && sh045Init.hanbaiSuuBtnShowOption == 1" style="width:20%"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <!--通常商品情報-->
                                                            <tr v-for="(item, idx) in oneHaisouInfo['TDK_ITEM_LIST']" :key="idx" style="font-weight:normal;">
                                                                <!-- 購入する商品のみ表示対応 -->
                                                                <template v-if="item.DISP_QTY > 0">
                                                                    <!--商品CD-->
                                                                    <td scope="row" :aria-label="$t('common.labels.productCode')">
                                                                        <div style="display:flex;align-items:center;gap: 6px;">
                                                                            <img v-if="sh045Init.itemImageShowOption == 1 && stringNvl(item.IMG_URL1,'') != ''" :src="item.IMG_URL1" :alt="stringNvl(item.WEB_ITEM_NM,'')" @error="getErrImage" class="item-image sh045-item-img">
                                                                            <span>{{item.ITEM_CD}}</span>
                                                                        </div>
                                                                    </td>
                                                                    <!--商品名-->
                                                                    <td :aria-label="$t('common.labels.productName')">
                                                                        <span class="cartOndo" v-if="stringNvl(item.ONDO_NM,'') != ''">【{{stringNvl(item.ONDO_NM,'')}}】</span>
                                                                        {{stringNvl(item.WEB_ITEM_NM,'')}}
                                                                    </td>
                                                                    <!--単価-->
                                                                    <td class="cart-price" :aria-label="$t('common.labels.unitPrice')" v-if="sh045Init.priceShow != 1">
                                                                        <!--税込-->
                                                                        <span v-if="sh045Init.orderInfo['TNK_DSP_KBN'] == '1'"> {{formatPrice(item.DISP_TNK_IN_ZEI)}}円 </span>
                                                                        <!--税抜-->
                                                                        <span v-else> {{formatPrice(item.DISP_TNK)}}円 </span>
                                                                    </td>
                                                                    <!--数量-->
                                                                    <td style="text-align: right;" :aria-label="$t('common.labels.quantity')">
                                                                        {{formatPrice(item.DISP_QTY)}}
                                                                    </td>
                                                                    <!--金額-->
                                                                    <!--税込-->
                                                                    <template v-if="sh045Init.orderInfo['TNK_DSP_KBN'] == '1' && sh045Init.priceShow != 1">
                                                                        <td class="cart-price" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.taxincluded')">
                                                                            <span class="price"> {{formatPrice(item.SHOUKEI_IN_ZEI)}}円 </span>
                                                                        </td>
                                                                    </template>
                                                                    <!--税抜-->
                                                                    <template v-else-if="sh045Init.priceShow != 1">
                                                                        <td class="cart-price" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.excludingtax')">
                                                                            <span class="price"> {{formatPrice(item.SHOUKEI)}}円 </span>
                                                                        </td>
                                                                    </template>
                                                                    <!--同梱品(可/不可)-->
                                                                    <template v-if="sh045Init.doukonHinOption == 1">
                                                                        <td :aria-label="sh045Init.doukonHinLabel">
                                                                            <span class="doukon-hin">{{ item.DOUKON_HIN_STATUS == 1 ? $t('sh045.labels.doukonHinOk') : $t('sh045.labels.doukonHinNg') }}</span>
                                                                        </td>
                                                                    </template>
                                                                    <!-- 商品在庫を見る-->
                                                                    <td class="hanbaiSuuCell" v-if="oneHaisouInfo['HANBAI_SUU_FLG'] == 1 && sh045Init.hanbaiSuuBtnShowOption == 1" style="width:20%">
                                                                        <span class="hanbaiQtyInfo" v-if="item.HANBAI_QTY_DISPLAY && item.HANBAI_QTY_DISPLAY === 1">
                                                                            <a href="#" @click.prevent="showModal(item.ITEM_CD,item.ITEM_NM1)" >{{$t('common.labels.productZaikoConf')}}</a>
                                                                        </span>
                                                                    </td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <!-- お届け希望日時 -->
                                                <!-- ECサイトオプション50504（非表示）かつ、ECサイトオプション50505（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                                                <div :class="'settingMainSh045CardHeader head2_' + haisouInfoIndex" v-if="(sh045Init.tdkkibouFlg == 1 || sh045Init.tdkTimeFlg == 1)">
                                                    <div :class="'settingMainSh045CardHeaderSub sub2_' + haisouInfoIndex">
                                                        <!-- 店頭受取以外の場合 90:店頭受取 -->
                                                        <div v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) != '90'" class="settingMainSh045CardHeaderSub1 sh045-inline-datetime-title">{{$t('sh060.labels.orderTdkDateArea')}}</div>
                                                        <!-- 店頭受取の場合 90:店頭受取 -->
                                                        <div v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'" class="settingMainSh045CardHeaderSub1 sh045-inline-pickup-title">{{$t('sh060.labels.pickupYmd')}}</div>
                                                    </div>
                                                </div>
                                                <!-- ECサイトオプション50504（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                                                <!-- 店頭受取以外の場合：配達希望日時設定 -->
                                                <div :class="'settingMainSh045CardBody sh045-inline-datetime-body body' + haisouInfoIndex" v-if="(sh045Init.tdkkibouFlg == 1 || sh045Init.tdkTimeFlg == 1) && stringNvl(oneTdkInfo['BINSYU_KBN']) != '90' && stringNvl(oneHaisouInfo['TDK_YMD_WAKU_DISP_FLG']) == '1'">
                                                    <!-- 希望日 -->
                                                    <div class="sh045-hope-date-block" v-if="sh045Init.tdkkibouFlg == 1 && stringNvl(oneHaisouInfo['TDK_YMD_DISP_FLG']) == '1'" style="padding:8px 0;">
                                                        <label :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?'text-danger':''" style="font-weight:bold;margin-bottom:4px;">{{$t('sh045.labels.hopeDates')}}</label>
                                                        <div class="sh045-hope-date-options" style="display:flex;flex-direction:column;gap:4px;">
                                                            <!-- 指定なし -->
                                                            <div class="sh045-hope-date-option-unset" style="display:flex;align-items:center;">
                                                                <input class="sh045-rdo-hope-day" type="radio" :name="'radioGroup1_' + oneHaisouInfo['TDK_SEQ']" :value="1"
                                                                    :disabled="oneHaisouInfo['HANBAI_SUU_FLG'] == 1 || (oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.radioGrp1Flg != 1)"
                                                                    v-model="oneHaisouInfo.radioGroup1" @click="hopeDayRadioInline(oneTdkInfo, oneHaisouInfo, 1)"/>
                                                                <label style="margin:0 8px;">{{$t("sh045.labels.unspecified")}}</label>
                                                            </div>
                                                            <!-- 日付指定 -->
                                                            <div class="sh045-hope-date-option-set" style="display:flex;align-items:center;">
                                                                <input class="sh045-rdo-hope-day" type="radio" :name="'radioGroup1_' + oneHaisouInfo['TDK_SEQ']" :value="2"
                                                                    :disabled="oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.radioGrp2Flg != 1"
                                                                    v-model="oneHaisouInfo.radioGroup1" @click="hopeDayRadioInline(oneTdkInfo, oneHaisouInfo, 2)"/>
                                                                <label style="margin:0 8px;">{{$t("sh045.labels.deliDateSetting")}}</label>
                                                                <select class="sh045-sel-hope-day" v-model="oneHaisouInfo.hopeTdkYmd" style="width:220px;"
                                                                    :id="'sh045_hopeTdkYmd_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                    :disabled="oneHaisouInfo.radioGroup1 != 2 || (oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.ymdHopeFlg != 1)"
                                                                    @change="hopeDayChangeInline(oneTdkInfo, oneHaisouInfo)">
                                                                    <option v-for="day in oneHaisouInfo.tdkYmdList" :value="day.KEY" :key="day.KEY">{{day.VALUE}}</option>
                                                                </select>
                                                            </div>
                                                            <!-- 以降指定 -->
                                                            <div class="sh045-hope-date-option-after" v-if="sh045Init.chakubiOption == 1" style="display:flex;align-items:center;">
                                                                <input class="sh045-rdo-hope-day" type="radio" :name="'radioGroup1_' + oneHaisouInfo['TDK_SEQ']" :value="3"
                                                                    :disabled="oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.radioGrp3Flg != 1"
                                                                    v-model="oneHaisouInfo.radioGroup1" @click="hopeDayRadioInline(oneTdkInfo, oneHaisouInfo, 3)"/>
                                                                <label style="margin:0 8px;"></label>
                                                                <select class="sh045-sel-hope-day" v-model="oneHaisouInfo.hopeTdkYmdAfter" style="width:220px;"
                                                                    :id="'sh045_hopeTdkYmdAfter_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                    :disabled="oneHaisouInfo.radioGroup1 != 3 || (oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.ymdAftFlg != 1)"
                                                                    @change="hopeDayChangeInline(oneTdkInfo, oneHaisouInfo)">
                                                                    <option v-for="day in oneHaisouInfo.tdkYmdList" :value="day.KEY" :key="day.KEY">{{day.VALUE}}</option>
                                                                </select>
                                                                <label style="margin:0 8px;">{{$t("sh045.labels.deliAfterDate")}}</label>
                                                            </div>
                                                            <!-- 販売数設定時：出荷予定日・在庫警告 -->
                                                            <template v-if="oneHaisouInfo['HANBAI_SUU_FLG'] == 1 && (oneHaisouInfo.radioGroup1 == 1 || oneHaisouInfo.radioGroup1 == 2 || (oneHaisouInfo.radioGroup1 == 3 && sh045Init.chakubiOption == 1))">
                                                                <span class="sh045-txt-shukka-yoteibi" v-if="oneHaisouInfo.shukkaYoteibi">出荷予定日：{{oneHaisouInfo.shukkaYoteibi}}</span>
                                                                <div class="sh045-txt-zaiko-warn" v-if="oneHaisouInfo.messages && oneHaisouInfo.messages.length">
                                                                    <div class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</div>
                                                                    <div class="error-message-warn">
                                                                        <span v-for="error in oneHaisouInfo.messages" :key="error">・{{ error }}<br></span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <div v-html="descriptionInfo[1]"></div>
                                                        </div>
                                                    </div>
                                                    <!-- 希望時間 -->
                                                    <div class="sh045-hope-time-block" v-if="sh045Init.tdkTimeFlg == 1 && stringNvl(oneHaisouInfo['TDK_HMS_DISP_FLG']) == '1'" style="padding:8px 0;">
                                                        <label :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG']) == '1'?'text-danger':''" style="font-weight:bold;margin-bottom:4px;">{{$t('sh045.labels.deliTime')}}</label>
                                                        <select class="sh045-sel-hope-time" v-model="oneHaisouInfo.hopeTdkTimeKbn" style="width:220px;"
                                                            :id="'sh045_hopeTdkTimeKbn_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                            :disabled="oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.timeHopeFlg != 1">
                                                            <option v-for="time in oneHaisouInfo.hopeTimeList" :value="time.KEY" :key="time.KEY" :disabled="time.disabled">{{time.VALUE}}</option>
                                                        </select>
                                                        <div v-html="descriptionInfo[2]"></div>
                                                    </div>
                                                </div>
                                                <!-- 店頭受取の場合：受取日設定 -->
                                                <div :class="'settingMainSh045CardBody sh045-inline-pickup-body body' + haisouInfoIndex" v-if="stringNvl(oneTdkInfo['BINSYU_KBN']) == '90'">
                                                    <div class="sh045-pickup-date-block" style="padding:8px 0;">
                                                        <label :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG']) == '1'?'text-danger':''" style="font-weight:bold;margin-bottom:4px;">{{$t('sh060.labels.pickupYmd1')}}</label>
                                                        <div class="sh045-pickup-date-select-row" style="display:flex;align-items:center;">
                                                            <select class="sh045-sel-hope-day" v-model="oneHaisouInfo.pickupYmd" style="width:220px;"
                                                                :disabled="oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.pickupYmdFlg != 1"
                                                                @change="hopeDayChangeInline(oneTdkInfo, oneHaisouInfo)">
                                                                <option v-for="day in oneHaisouInfo.tdkYmdList" :value="day.KEY" :key="day.KEY">{{day.VALUE}}</option>
                                                            </select>
                                                        </div>
                                                        <div v-html="descriptionInfo[3]"></div>
                                                    </div>
                                                    <!-- 希望時間 -->
                                                    <div class="sh045-hope-time-block" v-if="sh045Init.tdkTimeFlg == 1 && stringNvl(oneHaisouInfo['TDK_HMS_DISP_FLG']) == '1'" style="padding:8px 0;">
                                                        <label :class="stringNvl(oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG']) == '1'?'text-danger':''" style="font-weight:bold;margin-bottom:4px;">{{$t('sh045.labels.deliTime')}}</label>
                                                        <select class="sh045-sel-hope-time" v-model="oneHaisouInfo.hopeTdkTimeKbn" style="width:220px;"
                                                            :id="'sh045_hopeTdkTimeKbn_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                            :disabled="oneHaisouInfo.itemControl && oneHaisouInfo.itemControl.timeHopeFlg != 1">
                                                            <option v-for="time in oneHaisouInfo.hopeTimeList" :value="time.KEY" :key="time.KEY" :disabled="time.disabled">{{time.VALUE}}</option>
                                                        </select>
                                                        <div v-html="descriptionInfo[4]"></div>
                                                    </div>
                                                </div>
                                                <!-- ギフト設定 -->
                                                <div :class="'settingMainSh045CardHeader giftHead' + haisouInfoIndex" v-if="giftSectionVisible
                                                    && (oneHaisouInfo['housouOkFlg'] == 1)">
                                                    <div class="settingMainSh045CardHeaderSub">
                                                        <div class="settingMainSh045CardHeaderSub1">{{$t('sh060.labels.orderGistSetArea')}}</div>
                                                    </div>
                                                </div>
                                                <!-- ECサイトオプション50512（非表示）の場合は、ギフト設定の枠自体を非表示にする -->
                                                <div :class="'settingMainSh045CardBody giftBody' + haisouInfoIndex" v-if="giftSectionVisible
                                                    && (oneHaisouInfo['housouOkFlg'] == 1)">
                                                    <!-- ギフト設定 -->
                                                    <table class="table" style="border:0px;font-weight:normal">
                                                        <tbody>
                                                            <!-- のし・包装 -->
                                                            <tr class="tableTr" v-if="oneHaisouInfo['housouOkFlg'] == 1 && giftSectionVisible">
                                                                <th rowspan="7" class="housouTh">{{$t("sh045.labels.housouTh")}}</th>
                                                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                                                    <!-- 包装 -->
                                                                    <div v-if="sh045Init.housoushiFlg == 1" style="display:flex;align-items:center;">
                                                                        <label style="margin-bottom:0px;" class="text-danger">{{$t("sh045.labels.housouCd")}}</label>
                                                                        <select class="sh045-sel-housou-kbn" style="width:220px;"
                                                                            v-model="oneHaisouInfo['housouKbn']"
                                                                            v-on:change="housouKbnChangeInline(oneHaisouInfo)"
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1">
                                                                            <option v-for="item in sh045Init.housouKbnList" 
                                                                                :key="item.SAGYO_CD" :value="item.SAGYO_CD">{{item.SAGYO_NM}}</option>
                                                                        </select>
                                                                    </div>
                                                                    <!--のしサイズ -->
                                                                    <div style="display:flex;align-items:center;visibility:hidden;height:0px;" v-show="isFullPackageMode(oneHaisouInfo)">
                                                                        <span>{{$t("sh045.labels.noshiSizeKbn")}}</span>
                                                                        <select class="sh045-sel-noshi-size" style="width:150px;"
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                            v-model="oneHaisouInfo['noshiSizeKbn']">
                                                                            <option v-for="item in oneHaisouInfo['noshiSizeList']" 
                                                                                :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                                                        </select>
                                                                    </div>
                                                                    <!--水引 -->
                                                                    <div style="display:flex;align-items:center;visibility:hidden;height:0px;" v-show="isFullPackageMode(oneHaisouInfo)">
                                                                        <span>{{$t("sh045.labels.mizuHikiKbn")}}</span>
                                                                        <select class="sh045-sel-mizu-hiki" style="width:150px;"
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                            v-on:change="mizuHikiKbnChangeInline(oneHaisouInfo)"
                                                                            v-model="oneHaisouInfo['mizuHikiKbn']">
                                                                            <option v-for="item in sh045Init.mizuHikiKbnList" 
                                                                                :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                                                        </select>
                                                                    </div>
                                                                    <!--包装紙 -->
                                                                    <div style="display:flex;align-items:center;visibility:hidden;height:0px;" v-show="isFullPackageMode(oneHaisouInfo)">
                                                                        <span>{{$t('sh045.labels.housousi')}}</span>
                                                                        <select class="sh045-sel-housoushi" style="width:150px;"
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                            v-model="oneHaisouInfo['wappingKbn']">
                                                                            <option v-for="item in sh045Init.wappingKbnList" 
                                                                                :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                                                        </select>
                                                                    </div>
                                                                </td>
                                                                <!-- のし -->
                                                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                                                    <div v-if="sh045Init.nosiFlg == 1 || isFullPackageMode(oneHaisouInfo)" style="display:flex;align-items:center;">
                                                                        <label style="margin-bottom:0px;">{{$t("sh045.labels.noshiCd")}}</label>
                                                                        <!-- エコ包装 -->
                                                                        <select class="sh045-sel-noshi-cd" v-if="sh045Init.nosiFlg == 1 && !isFullPackageMode(oneHaisouInfo)" 
                                                                            style="width:220px;"
                                                                            :id="'noshiCd_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                            v-model="oneHaisouInfo['noshiCd']"
                                                                            :disabled="oneHaisouInfo['housouOkFlg'] != 1">
                                                                            <option v-for="item in sh045Init.noshiCdList" 
                                                                                :key="item.SAGYO_CD" :value="item.SAGYO_CD">{{item.SAGYO_NM}}</option>
                                                                        </select>
                                                                        <!-- 完全包装 -->
                                                                        <select class="sh045-sel-noshi-cd" v-if="isFullPackageMode(oneHaisouInfo)" 
                                                                            style="width:220px;"
                                                                            :id="'noshiCd_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                            v-model="oneHaisouInfo['noshiCd']"
                                                                            v-on:change="noshiCdChangeInline(oneHaisouInfo, $event.target.value)"
                                                                            :disabled="!(oneHaisouInfo['housouOkFlg'] == 1 && oneHaisouInfo['noshiOkFlg'] == 1)">
                                                                            <option v-for="item in sh045Init.noshiCdList1" 
                                                                                :key="item.SAGYO_CD" :value="item.SAGYO_CD">{{item.SAGYO_NM}}</option>
                                                                        </select>
                                                                    </div>
                                                                    <!--表書き１-->
                                                                    <div style="display:flex;align-items:center;visibility:hidden;height:0px;" v-show="isFullPackageMode(oneHaisouInfo)">
                                                                        <span>{{$t('sh045.labels.omotegaki1')}}</span>
                                                                        <input-check class="sh045-inp-omotegaki" v-model="oneHaisouInfo['omoteGaki1']" 
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                            :maxlength="24" size="15" />
                                                                    </div>
                                                                    <!--表書き２-->
                                                                    <div style="display:flex;align-items:center;visibility:hidden;height:0px;" v-show="isFullPackageMode(oneHaisouInfo)">
                                                                        <span>{{$t('sh045.labels.omotegaki2')}}</span>
                                                                        <input-check class="sh045-inp-omotegaki" v-model="oneHaisouInfo['omoteGaki2']" 
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                            :maxlength="24" size="15" />
                                                                    </div>
                                                                    <!--表書き３-->
                                                                    <div style="display:flex;align-items:center;visibility:hidden;height:0px;" v-show="isFullPackageMode(oneHaisouInfo)">
                                                                        <span>{{$t('sh045.labels.omotegaki3')}}</span>
                                                                        <input-check class="sh045-inp-omotegaki" v-model="oneHaisouInfo['omoteGaki3']" 
                                                                            :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                            :maxlength="24" size="15" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!-- エコ包装モード：名前・会社名・肩書 -->
                                                            <tr class="tableTr" v-if="oneHaisouInfo['housouOkFlg'] == 1 && sh045Init.noshiNaireFlg == 1 && !isFullPackageMode(oneHaisouInfo)">
                                                                <td colspan="2" bgcolor="#FFFFFF" height="60" class="td-res-height">
                                                                    <div style="display:flex;padding-bottom:12px;">
                                                                        <!-- 名前 -->
                                                                        <div style="display:flex;align-items:center;">
                                                                            <span style="margin-right:8px;">{{$t('sh045.labels.meimeiNm')}}</span>
                                                                            <input-check class="sh045-inp-naire" v-model="oneHaisouInfo['meimeiNm']" 
                                                                                :maxlength="10"
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1 && oneHaisouInfo['housouOkFlg'] != 1"
                                                                                size="12" />
                                                                        </div>
                                                                        <!-- 会社名 -->
                                                                        <div style="display:flex;align-items:center;">
                                                                            <span style="margin-right:8px;">{{$t('sh045.labels.compNm')}}</span>
                                                                            <input-check class="sh045-inp-naire" v-model="oneHaisouInfo['compNm']" 
                                                                                :id="'compNm_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                                :maxlength="10"
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1 && oneHaisouInfo['housouOkFlg'] != 1"
                                                                                size="12" />
                                                                        </div>
                                                                        <!-- 肩書 -->
                                                                        <div style="display:flex;align-items:center;">
                                                                            <span style="margin-right:8px;">{{$t('sh045.labels.compKatagaki')}}</span>
                                                                            <input-check class="sh045-inp-naire" v-model="oneHaisouInfo['compKatagaki']" 
                                                                                :maxlength="10"
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1 && oneHaisouInfo['housouOkFlg'] != 1"
                                                                                size="12" />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!-- 種別（完全包装モード） -->
                                                            <tr class="tableTr" v-if="isFullPackageMode(oneHaisouInfo) && oneHaisouInfo['housouOkFlg'] == 1">
                                                                <td colspan="2" bgcolor="#FFFFFF" height="200" class="td-res-height">
                                                                    <div class="sh045-syubetu-block" style="display:flex;padding-bottom:12px;">
                                                                        <div style="display:inline;">
                                                                            <input class="sh045-rdo-syubetu" type="radio" :name="'syubetu_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                value="1" @change="syubetuChangedInline(oneHaisouInfo)" v-model="oneHaisouInfo['syubetu']">
                                                                            <label style="margin-bottom:0px;padding-right:20px;">{{$t("sh045.labels.syubetu1")}}</label>
                                                                        </div>
                                                                        <div style="display:inline;">
                                                                            <input class="sh045-rdo-syubetu" type="radio" :name="'syubetu_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                value="2" @change="syubetuChangedInline(oneHaisouInfo)" v-model="oneHaisouInfo['syubetu']">
                                                                            <label style="margin-bottom:0px;padding-right:20px;">{{$t("sh045.labels.syubetu2")}}</label>
                                                                        </div>
                                                                        <div style="display:inline;">
                                                                            <input class="sh045-rdo-syubetu" type="radio" :name="'syubetu_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                value="3" @change="syubetuChangedInline(oneHaisouInfo)" v-model="oneHaisouInfo['syubetu']">
                                                                            <label style="margin-bottom:0px;padding-right:20px;">{{$t("sh045.labels.syubetu3")}}</label>
                                                                        </div>
                                                                        <div style="display:inline;">
                                                                            <input class="sh045-rdo-syubetu" type="radio" :name="'syubetu_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                value="4" @change="syubetuChangedInline(oneHaisouInfo)" v-model="oneHaisouInfo['syubetu']">
                                                                            <label style="margin-bottom:0px;padding-right:20px;">{{$t("sh045.labels.syubetu4")}}</label>
                                                                        </div>
                                                                        <div style="display:inline;">
                                                                            <input class="sh045-rdo-syubetu" type="radio" :name="'syubetu_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                value="5" @change="syubetuChangedInline(oneHaisouInfo)" v-model="oneHaisouInfo['syubetu']">
                                                                            <label style="margin-bottom:0px;">{{$t("sh045.labels.syubetu5")}}</label>
                                                                        </div>
                                                                    </div>
                                                                    <!--種別１，２，３：姓名入力-->
                                                                    <div class="sh045-simei-block" v-show="oneHaisouInfo['syubetu']=='1' || oneHaisouInfo['syubetu']=='2' || oneHaisouInfo['syubetu']=='3'">
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.sei1')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiSei1']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.mei1')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiMei1']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.sei2')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiSei2']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || (oneHaisouInfo['syubetu']=='1' || oneHaisouInfo['syubetu']=='2')" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.mei2')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiMei2']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || oneHaisouInfo['syubetu']=='1'" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.sei3')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiSei3']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || (oneHaisouInfo['syubetu']=='1' || oneHaisouInfo['syubetu']=='2')" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.mei3')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiMei3']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || oneHaisouInfo['syubetu']=='1'" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.sei4')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiSei4']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || (oneHaisouInfo['syubetu']=='1' || oneHaisouInfo['syubetu']=='2')" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.mei4')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiMei4']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || oneHaisouInfo['syubetu']=='1'" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.sei5')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiSei5']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || (oneHaisouInfo['syubetu']=='1' || oneHaisouInfo['syubetu']=='2')" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.mei5')}}</span>
                                                                                <input-check class="sh045-inp-simei" v-model="oneHaisouInfo['simeiMei5']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1 || oneHaisouInfo['syubetu']=='1'" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!--種別４：ルビ付き-->
                                                                    <div class="sh045-rubi-block" v-show="oneHaisouInfo['syubetu']=='4'">
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.namae1')}}</span>
                                                                                <input-check class="sh045-inp-namae" v-model="oneHaisouInfo['namae1']" :id="'namae1_' + tdkInfoIndex + '_' + haisouInfoIndex" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.rubi1')}}</span>
                                                                                <input-check class="sh045-inp-rubi" v-model="oneHaisouInfo['rubi1']" :id="'rubi1_' + tdkInfoIndex + '_' + haisouInfoIndex" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.namae2')}}</span>
                                                                                <input-check class="sh045-inp-namae" v-model="oneHaisouInfo['namae2']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.rubi2')}}</span>
                                                                                <input-check class="sh045-inp-rubi" v-model="oneHaisouInfo['rubi2']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.namae3')}}</span>
                                                                                <input-check class="sh045-inp-namae" v-model="oneHaisouInfo['namae3']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.rubi3')}}</span>
                                                                                <input-check class="sh045-inp-rubi" v-model="oneHaisouInfo['rubi3']" :disabled="oneHaisouInfo['noshiOkFlg'] != 1" :maxlength="12" style="height:40px;" size="20" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!--種別５：法人-->
                                                                    <div class="sh045-comp-block" v-show="oneHaisouInfo['syubetu']=='5'">
                                                                        <!--会社種別-->
                                                                        <div style="display: grid;grid-template-columns: min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.compSyubetu')}}</span>
                                                                                <input class="sh045-rdo-comp-syubetu" type="radio" :id="'compSyubetu1_' + tdkInfoIndex + '_' + haisouInfoIndex" :name="'compSyubetuCd_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    value="1" v-model="oneHaisouInfo['compSyubetuCd']">
                                                                                <label style="white-space: nowrap;margin:0 5px 0 0;">{{$t("sh045.labels.compSyubetu1")}}</label>
                                                                                <input class="sh045-rdo-comp-syubetu" type="radio" :id="'compSyubetu2_' + tdkInfoIndex + '_' + haisouInfoIndex" :name="'compSyubetuCd_' + tdkInfoIndex + '_' + haisouInfoIndex" 
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    value="2" v-model="oneHaisouInfo['compSyubetuCd']">
                                                                                <label style="white-space: nowrap;margin:0 5px 0 0;">{{$t("sh045.labels.compSyubetu2")}}</label>
                                                                                <select class="sh045-sel-comp-syubetu" v-on:change="compSyubetuChangeInline(oneHaisouInfo, $event)"
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    style="height:40px;">
                                                                                    <option v-for="(item, index) in sh045Init.compKindList" 
                                                                                        :key="item.KEY" :value="item.KEY"
                                                                                        :style="index === 0 ? 'color: #bbb;' : ''">
                                                                                        {{index === 0 ? '選択してください' : item.VALUE}}</option>
                                                                                </select>
                                                                                <div class="sh045-flex-comp-syubetu" style="display:inline-flex;align-items:center;margin:0;">
                                                                                    <input-check class="sh045-inp-comp-syubetu-nm" v-model="oneHaisouInfo['compSyubetuNm']" 
                                                                                        :id="'compSyubetuNm_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                                        :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                        :maxlength="10" style="height:40px;" size="15" />
                                                                                    <span class="sh045-msg-comp-syubetu" style="white-space: nowrap;padding-right:5px;">{{$t('sh045.messages.noshiCompListMessage')}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <!--会社名-->
                                                                        <div style="display: grid;grid-template-columns: min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.compNm')}}</span>
                                                                                <input-check class="sh045-inp-comp-nm" v-model="oneHaisouInfo['compNm']" 
                                                                                    :id="'compNm_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    :maxlength="40" style="height:40px;" size="22" />
                                                                            </div>
                                                                        </div>
                                                                        <!--部署名-->
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.compBusyo')}}</span>
                                                                                <input-check class="sh045-inp-busyo" v-model="oneHaisouInfo['compBusyo1']" 
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    :maxlength="50" style="height:40px;" size="22" />
                                                                            </div>
                                                                            <div style="align-items:center;margin:0;">
                                                                                <input-check class="sh045-inp-busyo" v-model="oneHaisouInfo['compBusyo2']" 
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    :maxlength="50" style="height:40px;" size="22" />
                                                                            </div>
                                                                        </div>
                                                                        <!--肩書-->
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;margin:0;">
                                                                                <span style="white-space: nowrap;margin:0 15px 0 0;padding-right:10px;">{{$t('sh045.labels.compKatagaki')}}</span>
                                                                                <select class="sh045-sel-comp-katagaki" v-on:change="compKatagakiChangeInline(oneHaisouInfo, $event)"
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1">
                                                                                    <option v-for="(item, index) in sh045Init.compKatagakiList" 
                                                                                        :key="item.KEY" :value="item.KEY"
                                                                                        :style="index === 0 ? 'color: #bbb;' : ''">
                                                                                        {{index === 0 ? '選択してください' : item.VALUE}}</option>
                                                                                </select>
                                                                            </div>
                                                                            <div style="align-items:center;">
                                                                                <div class="sh045-flex-comp-katagaki" style="display:inline-flex;align-items:center;margin:0;">
                                                                                    <input-check class="sh045-inp-comp-katagaki" v-model="oneHaisouInfo['compKatagaki']" 
                                                                                        :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                        :maxlength="20" style="height:40px;" size="22" />
                                                                                    <span class="sh045-msg-comp-katagaki" style="white-space: nowrap;padding-right:5px;">{{$t('sh045.messages.noshiCompListMessage')}}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <!--個人-->
                                                                        <div style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                                                            <div style="align-items:center;">
                                                                                <span style="white-space: nowrap;padding-right:10px;">{{$t('sh045.labels.compKojinNm')}}</span>
                                                                                <input-check class="sh045-inp-kojin-nm" v-model="oneHaisouInfo['compKojinNm1']" 
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    :maxlength="12" style="height:40px;" size="22" />
                                                                            </div>
                                                                            <div style="align-items:center;margin:0;">
                                                                                <input-check class="sh045-inp-kojin-nm" v-model="oneHaisouInfo['compKojinNm2']" 
                                                                                    :disabled="oneHaisouInfo['noshiOkFlg'] != 1"
                                                                                    :maxlength="12" style="height:40px;" size="22" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div v-html="descriptionInfo[5]"></div>
                                                </div>
                                                <!-- 同梱品設定 -->
                                                <div :class="'settingMainSh045CardBody sh045-inline-doukon-hin-body body' + haisouInfoIndex" v-if="isDoukonHinAvailable(oneHaisouInfo)">
                                                    <div class="sh045-doukon-hin-block" style="padding:8px 0;">
                                                        <div class="sh045-doukon-hin-label" style="font-weight:bold;">{{sh045Init.doukonHinLabel}}</div>
                                                        <label :for="'doukonHinCheckBox_' + tdkInfoIndex + '_' + haisouInfoIndex">
                                                            <input class="sh045-chk-doukon-hin" type="checkbox" :id="'doukonHinCheckBox_' + tdkInfoIndex + '_' + haisouInfoIndex"
                                                                true-value="1" false-value="0" v-model="oneHaisouInfo['doukonHinFlg']">
                                                            {{$t("common.labels.there")}}
                                                        </label>
                                                        <div v-html="descriptionInfo[10]"></div>
                                                    </div>
                                                </div>
                                                <!-- この配送ギフト設定をすべてに反映する -->
                                                <div :class="'settingMainSh045CardHeader giftSet' + haisouInfoIndex" v-if="sh045Init.copyTdkGiftOption == 1 && !isSettingsUnavailable(oneTdkInfo, oneHaisouInfo)
                                                        && ((sh045Init.tdkInfo && sh045Init.tdkInfo.length > 1) || oneTdkInfo.TDK_HAISOU_LIST.length > 1)">
                                                    <div :class="'settingMainSh045CardHeaderSub giftSub' + haisouInfoIndex" style="border-bottom:none;margin-bottom:0;">
                                                        <div class="settingMainSh045CardHeaderSub2"><a href="javascript:void(0)" 
                                                            @click="copyTdkGiftSettingConfirm(oneHaisouInfo['TDK_SEQ'],oneHaisouInfo['TDK_NO']);" 
                                                            id="copyTdkGiftSetting" class="card-link">{{$t('sh060.buttons.copyTdkGiftSetting')}}</a></div>
                                                    </div>
                                                    <div v-html="descriptionInfo[6]"></div>
                                                </div>
                                                <!-- この配送ではお届け希望日時等の指定は不可となります。 -->
                                                <div v-if="isSettingsUnavailable(oneTdkInfo, oneHaisouInfo)"
                                                     class="settings-unavailable-msg">
                                                    {{$t('sh045.messages.dateTimeGiftSettingsUnavailable')}}
                                                </div>
                                            </div>
                                            <br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                </div>
            </div>
            <ul class="button-column">
                <!-- 前のページへ戻る -->
                <li>
                    <input class="submit-button back-btn" type="submit" @click="goBack()" :value="$t('common.buttons.backtothepreviouspage')">
                </li>
                <!-- 次へ進む -->
                <li>
                    <button @click="doConfirmSubmit" type="button">
                        {{ sh045Init.stepBasedFlg == 1 || sh045Init.catalogFlg == 1 ? $t("common.buttons.proceedNext") : $t("common.buttons.change") }}
                    </button>
                </li>
            </ul>

            <!-- modal confirm area -->
            <alert-confirm 
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :isButtonCancel="isButtonCancel">
            </alert-confirm>

            <alert-confirm
                v-if="isErrorAlert"
                :msgConfirm="errorMsg"
                :isButtonCancel="false"
                @closedModal="isErrorAlert=false"
                size="md"
            ></alert-confirm>

            <alert-confirm 
                v-if="isModalAreaCheckShow"
                :msgConfirm="msgConfirmAreaCheck"
                @closedModal="isModalAreaCheckShow = false"
                :size="'lg'"
                :isButtonOK="false"
                :isHideFooter="true"  
                :isHideHeader="true"  
                :isCloseBackdrop="false"
                :isButtonCancel="isButtonCancelAreaCheck">
            </alert-confirm>

            <!-- この配送ギフト設定をすべてに反映します。よろしいですか？ -->
            <alert-confirm
                v-if="isShowGiftSettingCopyAlert"
                :msgConfirm="outputMsgConfirm"
                :okAction="doCopyTdkGiftSetting"
                :cancelAction="()=>{isShowGiftSettingCopyAlert = false;}"
                @closedModal="isShowGiftSettingCopyAlert = false"
                size="md"
            />

            <!-- 販売数モーダル -->
            <ModalComponent
                v-if="isModalVisible"
                :show="isModalVisible"
                :tableData="tableData"
                :selectedShouhin="selectedShouhin"
                :selectedShouhinLst="selectedShouhinLst"
                :note="note"
                @close="isModalVisible = false"/>

            <!-- バリデーション用ラベル（非表示） -->
            <span id="noshiCd_lbl" hidden>{{$t("sh045.labels.noshiCd")}}</span>
            <span id="namae1_lbl" hidden>{{$t('sh045.labels.namae1')}}</span>
            <span id="rubi1_lbl" hidden>{{$t('sh045.labels.rubi1')}}</span>
            <span id="compSyubetuCd_lbl" hidden>{{$t('sh045.labels.compSyubetu')}}</span>
            <span id="compSyubetuNm_lbl" hidden>{{$t('sh045.labels.compSyubetu')}}</span>
            <span id="compNm_lbl" hidden>{{$t('sh045.labels.compNm')}}</span>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import $ from 'jquery';
import axios from "assets/js/request";
import common from 'assets/js/common';
import EventBus from 'assets/js/eventBus';
import InputCheck from "components/InputCheck";
import Message from 'components/MessageEcSite';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import ModalComponent from '../popup/HanbaiSuuSettingPopup.vue';

export default {
    /*
    * Name of component
    */
    name: "SH045",
    /*
    * Declare components
    */
    components: {
        Message: Message,
        InputCheck,
        AlertConfirm,
        ModalComponent,
    },
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            SH045_PART: "sh045",
            listMessValid: [],
            mapMessValid: [],
            errorMessages: [],
            isLoading: false,
            loadingMessage: '',
            loginPage: 0,
            scrollId: '',
            tdkSeq: null,
            sh060: {},
            sh045Init: {
                orderInfo: {},
                descriptionInfo: {},
            },
            sh045Request: {
            },
            isButtonCancel: true,
            isButtonCancelAreaCheck: true,
            actionFlg: 0,
            isModalShow: false,
            msgConfirm: '',
            isErrorAlert: false,
            errorMsg: '',
            isModalAreaCheckShow: false,
            msgConfirmAreaCheck: '',
            isShowGiftSettingCopyAlert: false,
            outputMsgConfirm: '',
            listIdErr: [],
            descriptionInfo: [],
            SiteConstants: SiteConstants,
            Constants: Constants,
            NO_CART_ERR: "001",
            CART_INFO_INVALID_ERR: "002",
            SHOW_ERR_PAGE: "003",
            BESE_KIN_ERR: "004",
            LEAD_DAY_ERR: "005",
            noCartErrFlg: 0,
            reqModel: {
                tdkNo: null,
                tdkSeq: null,
                tdkMSeq: null,
                tdkFlg: null,
                tdkYmd: null,
                tdkHmsKbn: null,
                tdkYmdHissuFlg: null,
                tdkYmdErrFlg: null,
                tdkHstmHissuFlg: null,
                tdkHstmHErrFlg: null,
                chakubiKbn: null,
                updChakubiKbn: null,
            },
            copyRequestModel: {
                tdkSeq: null,
                tdkNo: null,
            },
            doinitFlg: false,
            isModalVisible: false,
            tableData: [],
            selectedShouhinLst: [],
            selectedShouhin: '',
            note: '',
        };
    },
    /*
    * Initialize
    */
    mounted: function() {
        this.doInit();
        if (this.noCartErrFlg == 1) {
            return;
        }
    },
    computed: {
        // エコ包装機能が有効か（KANRI_NO: 13656 が設定されているか）
        ecoHousouEnabled: function() {
            return this.sh045Init.ecoHousouLst != null && this.sh045Init.ecoHousouLst.length > 0;
        },
        // ギフト設定エリアを表示するか（のし/包装紙/名入れのいずれかが有効）
        giftSectionVisible: function() {
            return this.sh045Init.nosiFlg == 1
                || this.sh045Init.housoushiFlg == 1
                || this.sh045Init.noshiNaireFlg == 1;
        },
    },
    /*
    * Methods
    */
    methods: {

        // 同梱品設定可の配送先かどうか判定する
        isDoukonHinAvailable: function(oneHaisouInfo) {
            const okKbnList = this.sh045Init.doukonHinOkKbnList;

            // 配送先の同梱品設定可フラグが1でない場合は、同梱品設定不可
            // 同梱品設定可の包装区分が設定されていない場合、または、包装区分が同梱品設定可として設定されている場合は、同梱品設定可とする
            return oneHaisouInfo.doukonHinOkFlg === 1
                && (
                    !okKbnList ||
                    okKbnList.length === 0 ||
                    okKbnList.includes(oneHaisouInfo['housouKbn'])
                );
        },

        // お届け希望日時・ギフトの指定が不可の配送先かどうか判定する
        isSettingsUnavailable: function(oneTdkInfo, oneHaisouInfo) {
            // 包装可 → メッセージ不要
            if (oneHaisouInfo['housouOkFlg'] == 1) {
                return false;
            }
            // itemControl 未設定 → メッセージ表示
            if (!oneHaisouInfo.itemControl) {
                return true;
            }
            var ic = oneHaisouInfo.itemControl;
            var binsyuKbn = this.stringNvl(oneTdkInfo['BINSYU_KBN']);
            if (binsyuKbn === '90') {
                // 店頭受取：受取日 or 希望時間が可能なら非表示
                return !(ic.pickupYmdFlg == 1 || ic.timeHopeFlg == 1);
            }
            // 通常配送：希望日(のみ) or 希望日(以降) or 希望時間が可能なら非表示
            return !(ic.ymdHopeFlg == 1 || ic.ymdAftFlg == 1 || ic.timeHopeFlg == 1);
        },

        // エコ包装機能あり かつ 配送単位が完全包装モードか
        isFullPackageMode: function(info) {
            return this.ecoHousouEnabled && info['ecoHousouMode'] == '0';
        },

        // 販売数モーダルウィンドウを表示する
        showModal(itemCd, itemNm) {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + "/getShipYotei", itemCd + ":" + itemNm).then(function(response) {
                if (response.data && response.data.inventoryItemModelLst) {
                    _this.tableData = response.data.inventoryItemModelLst;
                    _this.selectedShouhinLst = response.data.itemNmLst;
                    var shouhin = response.data.colSizList.find(item => item['KEY'] === itemCd);
                    _this.selectedShouhin = shouhin ? shouhin['VALUE'] : itemNm;
                    _this.isModalVisible = true;
                    _this.note = response.data.memo;
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        },

        doInit() {
            var _this = this;
            _this.$emit("event-loading", true);
            if (_this.ptInitData && !_this.doinitFlg) {
                _this.sh045Init = _this.ptInitData;
                _this.sh045Request = Object.assign({}, _this.sh045Request, _this.ptInitData);
                _this.descriptionInfo = _this.sh045Init.descriptionInfo;
                if (_this.ptInitData.respCode == _this.NO_CART_ERR) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 16 } });
                    _this.noCartErrFlg = 1;
                    _this.$emit("event-loading", false);
                    return;
                }
                if (_this.ptInitData.respCode == _this.CART_INFO_INVALID_ERR) {
                    _this.$router.push({ name: 'Warning' });
                    _this.$emit("event-loading", false);
                    return;
                }
                if (_this.ptInitData.errList != null && _this.ptInitData.errList.length > 0) {
                    _this.displayWarning(_this.ptInitData.errList);
                }
                // cartSplitUseFlg==1の場合、各配送単位のギフトデータを初期化
                if (_this.sh045Init.cartSplitUseFlg == 1 && _this.sh045Init.tdkInfo) {
                    for (var ti = 0; ti < _this.sh045Init.tdkInfo.length; ti++) {
                        var haisouList = _this.sh045Init.tdkInfo[ti].TDK_HAISOU_LIST;
                        if (haisouList) {
                            for (var hi = 0; hi < haisouList.length; hi++) {
                                _this.initHaisouGiftData(haisouList[hi]);
                            }
                        }
                    }
                }
                // 非カート分割時：tdkInfoの各届先にhopeTdkYmd等をリアクティブにセット
                if (_this.sh045Init.cartSplitUseFlg != 1 && _this.sh045Init.tdkInfo) {
                    for (var i = 0; i < _this.sh045Init.tdkInfo.length; i++) {
                        var tdkItem = _this.sh045Init.tdkInfo[i];
                        _this.$set(tdkItem, 'hopeTdkYmd', tdkItem['TDK_YMD'] || '');
                        _this.$set(tdkItem, 'hopeTdkTimeKbn', tdkItem['TDK_HMS_KBN'] || '');
                        // radioGroup1初期値：着日フラグ・販売数フラグにより決定（SH030準拠）
                        var hissuFlg = tdkItem['TDK_YMD_HISSU_FLG'];
                        var errFlg   = tdkItem['TDK_YMD_ERR_FLG'];
                        var hanbaiFlg = tdkItem['HANBAI_SUU_FLG'];
                        var initRadio;
                        if (tdkItem['TDK_YMD']) {
                            // 既に希望日が設定されている場合はそれを優先
                            initRadio = 2;
                        } else if ((hissuFlg == 0) && (errFlg == 1) && (hanbaiFlg == 0 || hanbaiFlg == null)) {
                            initRadio = 1; // 着日指定不可 → 指定なし固定
                        } else if ((hissuFlg == 1) && (errFlg == 0) || (hanbaiFlg != 0 && hanbaiFlg != null)) {
                            initRadio = 2; // 着日必須 or 販売数あり → 日付指定固定
                        } else {
                            initRadio = 1; // 通常 → デフォルト指定なし
                        }
                        _this.$set(tdkItem, 'radioGroup1', initRadio);
                        // 配達希望日・時間帯リスト（届先ごと）
                        if (tdkItem['tdkYmdList']) _this.$set(tdkItem, 'tdkYmdList', tdkItem['tdkYmdList']);
                        if (tdkItem['hopeTimeList']) _this.$set(tdkItem, 'hopeTimeList', tdkItem['hopeTimeList']);
                        // ギフト設定の初期値（届先ごと）
                        _this.$set(tdkItem, 'sagyoKanriKomokuCd', tdkItem['SAGYO_CD1'] || '');
                        _this.$set(tdkItem, 'sagyoKanriKomokuCd2', tdkItem['SAGYO_CD2'] || '');
                        _this.$set(tdkItem, 'noshiNaire1', tdkItem['NOSHI_NAIRE1'] || '');
                        _this.$set(tdkItem, 'noshiNaire2', tdkItem['NOSHI_NAIRE2'] || '');
                        // 初期表示時の出荷予定日取得（販売数設定あり かつ 希望日あり）
                        if (tdkItem['HANBAI_SUU_FLG'] == 1 && tdkItem['TDK_YMD']) {
                            _this.fetchShipYoteibi(tdkItem, tdkItem['TDK_YMD'], tdkItem['TDK_ZIP'] || '', tdkItem['TDK_KEN'] || '');
                        }
                    }
                }
                _this.$nextTick(function() { _this.scroll(); });
                _this.$emit("event-loading", false);
                return;
            }

            _this.doinitFlg = false;
            var host = window.location.protocol + "//" + window.location.host;
            let request = { clientHost: host };
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + _this.$UrlConstants.DO_INIT, request).then(function(response) {
                _this.sh045Init = response.data;
                _this.sh045Request = Object.assign({}, _this.sh045Request, response.data.reqModel);
                _this.descriptionInfo = _this.sh045Init.descriptionInfo;
                if (response.data.respCode == _this.NO_CART_ERR) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 16 } });
                    _this.noCartErrFlg = 1;
                    _this.$emit("event-loading", false);
                    return;
                }
                if (response.data.respCode == _this.CART_INFO_INVALID_ERR) {
                    _this.$router.push({ name: 'Warning' });
                    return;
                }
                if (response.data.errList != null && response.data.errList.length > 0) {
                    _this.displayWarning(response.data.errList);
                }
                // cartSplitUseFlg==1の場合、各配送単位のギフトデータを初期化
                if (_this.sh045Init.cartSplitUseFlg == 1 && _this.sh045Init.tdkInfo) {
                    for (var ti = 0; ti < _this.sh045Init.tdkInfo.length; ti++) {
                        var haisouList = _this.sh045Init.tdkInfo[ti].TDK_HAISOU_LIST;
                        if (haisouList) {
                            for (var hi = 0; hi < haisouList.length; hi++) {
                                _this.initHaisouGiftData(haisouList[hi]);
                            }
                        }
                    }
                }
                // 非カート分割時：tdkInfoの各届先にhopeTdkYmd等をリアクティブにセット
                if (_this.sh045Init.cartSplitUseFlg != 1 && _this.sh045Init.tdkInfo) {
                    for (var i = 0; i < _this.sh045Init.tdkInfo.length; i++) {
                        var tdkItem = _this.sh045Init.tdkInfo[i];
                        _this.$set(tdkItem, 'hopeTdkYmd', tdkItem['TDK_YMD'] || '');
                        _this.$set(tdkItem, 'hopeTdkTimeKbn', tdkItem['TDK_HMS_KBN'] || '');
                        // radioGroup1初期値：着日フラグ・販売数フラグにより決定
                        var hissuFlg = tdkItem['TDK_YMD_HISSU_FLG'];
                        var errFlg   = tdkItem['TDK_YMD_ERR_FLG'];
                        var hanbaiFlg = tdkItem['HANBAI_SUU_FLG'];
                        var initRadio;
                        if (tdkItem['TDK_YMD']) {
                            // 既に希望日が設定されている場合はそれを優先
                            initRadio = 2;
                        } else if ((hissuFlg == 0) && (errFlg == 1) && (hanbaiFlg == 0 || hanbaiFlg == null)) {
                            initRadio = 1; // 着日指定不可 → 指定なし固定
                        } else if ((hissuFlg == 1) && (errFlg == 0) || (hanbaiFlg != 0 && hanbaiFlg != null)) {
                            initRadio = 2; // 着日必須 or 販売数あり → 日付指定固定
                        } else {
                            initRadio = 1; // 通常 → デフォルト指定なし
                        }
                        _this.$set(tdkItem, 'radioGroup1', initRadio);
                        // 配達希望日・時間帯リスト（届先ごと）
                        if (tdkItem['tdkYmdList']) _this.$set(tdkItem, 'tdkYmdList', tdkItem['tdkYmdList']);
                        if (tdkItem['hopeTimeList']) _this.$set(tdkItem, 'hopeTimeList', tdkItem['hopeTimeList']);
                        // ギフト設定の初期値（届先ごと）
                        _this.$set(tdkItem, 'sagyoKanriKomokuCd', tdkItem['SAGYO_CD1'] || '');
                        _this.$set(tdkItem, 'sagyoKanriKomokuCd2', tdkItem['SAGYO_CD2'] || '');
                        _this.$set(tdkItem, 'noshiNaire1', tdkItem['NOSHI_NAIRE1'] || '');
                        _this.$set(tdkItem, 'noshiNaire2', tdkItem['NOSHI_NAIRE2'] || '');
                        // 初期表示時の出荷予定日取得（販売数設定あり かつ 希望日あり）
                        if (tdkItem['HANBAI_SUU_FLG'] == 1 && tdkItem['TDK_YMD']) {
                            _this.fetchShipYoteibi(tdkItem, tdkItem['TDK_YMD'], tdkItem['TDK_ZIP'] || '', tdkItem['TDK_KEN'] || '');
                        }
                    }
                }
                _this.$nextTick(function() { _this.scroll(); });
            }).catch(function(error) {
                common.errorAPI(error);
            }).finally(function() {
                _this.$emit("event-loading", false);
            });
        },

        // 配送単位用ラジオボタン変更（カート分割用）
        hopeDayRadioInline: function(oneTdkInfo, oneHaisouInfo, data) {
            var _this = this;
            if (data == 1) {
                oneHaisouInfo.hopeTdkYmd = '';
                oneHaisouInfo.hopeTdkYmdAfter = '';
            } else if (data == 2) {
                oneHaisouInfo.hopeTdkYmdAfter = '';
            } else if (data == 3) {
                oneHaisouInfo.hopeTdkYmd = '';
            }
            var hopeDay = '';
            if (data == 1) {
                hopeDay = '';
            } else if (data == 2) {
                hopeDay = oneHaisouInfo.hopeTdkYmd || '';
            } else if (data == 3) {
                hopeDay = oneHaisouInfo.hopeTdkYmdAfter || '';
            }
            // 配達希望日変更処理
            _this.saveHopeDate(
                String(oneHaisouInfo['TDK_SEQ'] != null ? oneHaisouInfo['TDK_SEQ'] : ''),
                String(oneHaisouInfo['TDK_NO'] != null ? oneHaisouInfo['TDK_NO'] : '0'),
                hopeDay,
                oneHaisouInfo.hopeTdkTimeKbn || '',
                (data == 1) ? '0' : (data == 2) ? '1' : '2',
                (oneHaisouInfo['TDK_ITEM_LIST'] && oneHaisouInfo['TDK_ITEM_LIST'][0]) ? (oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG'] || 0) : 0,
                oneTdkInfo['TDK_ZIP'] || ''
            );
            var shipHopeDay = hopeDay;
            if (data == 1 && oneHaisouInfo.tdkYmdList && oneHaisouInfo.tdkYmdList.length > 1) {
                shipHopeDay = oneHaisouInfo.tdkYmdList[1]['KEY'];
            }
            _this.fetchShipYoteibi(oneHaisouInfo, shipHopeDay, oneTdkInfo['TDK_ZIP'] || '', oneTdkInfo['TDK_KEN'] || '');
            _this.$forceUpdate();
        },

        // 配送単位用日付セレクト変更（カート分割用）
        hopeDayChangeInline: function(oneTdkInfo, oneHaisouInfo) {
            var _this = this;
            var hopeDay = oneHaisouInfo.hopeTdkYmd || oneHaisouInfo.hopeTdkYmdAfter || oneHaisouInfo.pickupYmd || '';
            var radioVal = oneHaisouInfo.radioGroup1 || 1;
            // 配達希望日変更処理
            _this.saveHopeDate(
                String(oneHaisouInfo['TDK_SEQ'] != null ? oneHaisouInfo['TDK_SEQ'] : ''),
                String(oneHaisouInfo['TDK_NO'] != null ? oneHaisouInfo['TDK_NO'] : '0'),
                hopeDay,
                oneHaisouInfo.hopeTdkTimeKbn || '',
                (radioVal == 2) ? '1' : (radioVal == 3) ? '2' : '0',
                (oneHaisouInfo['TDK_ITEM_LIST'] && oneHaisouInfo['TDK_ITEM_LIST'][0]) ? (oneHaisouInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG'] || 0) : 0,
                oneTdkInfo['TDK_ZIP'] || ''
            );
            _this.fetchShipYoteibi(oneHaisouInfo, hopeDay, oneTdkInfo['TDK_ZIP'] || '', oneTdkInfo['TDK_KEN'] || '');
        },

        // 配送希望日選択時 data:1 指定なし  data:2 日付指定（非カート分割用）
        hopeDayRadio: function(data, tdkIdx) {
            var _this = this;
            if (_this.sh045Init.tdkInfo && _this.sh045Init.tdkInfo[tdkIdx]) {
                var tdk = _this.sh045Init.tdkInfo[tdkIdx];
                if (data == 1) {
                    _this.$set(tdk, 'hopeTdkYmd', '');
                }
                _this.saveHopeDate(
                    String(tdk['TDK_SEQ'] != null ? tdk['TDK_SEQ'] : ''),
                    String(tdk['TDK_NO'] != null ? tdk['TDK_NO'] : '0'),
                    (data == 1) ? '' : (tdk.hopeTdkYmd || ''),
                    tdk.hopeTdkTimeKbn || '',
                    (data == 1) ? '0' : '1',
                    tdk['TDK_HSTM_HISSU_FLG'] || 0,
                    tdk['TDK_ZIP'] || ''
                );
                var shipHopeDay = (data == 1) ? '' : (tdk.hopeTdkYmd || '');
                if (data == 1 && tdk.tdkYmdList && tdk.tdkYmdList.length > 1) {
                    shipHopeDay = tdk.tdkYmdList[1]['KEY'];
                }
                _this.fetchShipYoteibi(tdk, shipHopeDay, tdk['TDK_ZIP'] || '', tdk['TDK_KEN'] || '');
            }
            _this.$forceUpdate();
        },

        // 非カート分割：配達希望時間変更処理
        hopeDayChange: function(oneTdkInfo, tdkIdx) {
            var _this = this;
            if (!_this.sh045Init.tdkInfo || !_this.sh045Init.tdkInfo[tdkIdx]) return;
            var tdk = _this.sh045Init.tdkInfo[tdkIdx];
            var radioVal = tdk.radioGroup1 || 1;
            var hopeTdkYmd = (radioVal == 2) ? (tdk.hopeTdkYmd || '') : '';
            var reqModel = {
                tdkSeq: String(tdk['TDK_SEQ'] != null ? tdk['TDK_SEQ'] : ''),
                tdkNo: String(tdk['TDK_NO'] != null ? tdk['TDK_NO'] : '0'),
                tdkZipCd: String(tdk['TDK_ZIP'] != null ? tdk['TDK_ZIP'] : ''),
                hopeTdkYmd: hopeTdkYmd,
                hopeTdkTimeKbn: tdk.hopeTdkTimeKbn || '',
                updChakubiKbn: (radioVal == 2) ? '1' : '0',
                tdkHstmHissuFlg: tdk['TDK_HSTM_HISSU_FLG'] || 0
            };
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + '/updateHopeDate', reqModel).then(function(response) {
                // 時間帯リストを絞り込み結果で更新
                if (response.data && response.data.hopeTimeList) {
                    var newList = response.data.hopeTimeList;
                    _this.$set(tdk, 'hopeTimeList', newList);
                    // 現在選択中の時間帯が新リストに存在しない場合はクリア
                    var currentKbn = tdk.hopeTdkTimeKbn || '';
                    var stillExists = newList.some(function(item) { return item.KEY == currentKbn; });
                    if (!stillExists) {
                        _this.$set(tdk, 'hopeTdkTimeKbn', '');
                    }
                }
                _this.fetchShipYoteibi(tdk, hopeTdkYmd, tdk['TDK_ZIP'] || '', tdk['TDK_KEN'] || '');
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },

        // 出荷予定日取得（HANBAI_SUU_FLG==1のときAPIを呼び出してshukkaYoteibiをセット）
        fetchShipYoteibi: function(target, hopeDay, tdkZip, tdkKen) {
            var _this = this;
            if (target['HANBAI_SUU_FLG'] != 1) return;
            _this.$set(target, 'messages', []);
            var reqData = {
                hopeDay: hopeDay,
                tdkZip: tdkZip,
                tdkKen: tdkKen
            };
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + '/getShipYoteiCheck', reqData).then(function(res) {
                _this.$set(target, 'shukkaYoteibi', res.data.shukkaYoteibi || '');
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },

        // カート分割：配達希望時間変更処理
        saveHopeDate: function(tdkSeq, tdkNo, hopeTdkYmd, hopeTdkTimeKbn, updChakubiKbn, tdkHstmHissuFlg, tdkZipCd) {
            var _this = this;
            var reqModel = {
                tdkSeq: tdkSeq,
                tdkNo: tdkNo,
                tdkZipCd: tdkZipCd || '',
                hopeTdkYmd: hopeTdkYmd,
                hopeTdkTimeKbn: hopeTdkTimeKbn,
                updChakubiKbn: updChakubiKbn,
                tdkHstmHissuFlg: tdkHstmHissuFlg || 0
            };
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + '/updateHopeDate', reqModel).then(function(response) {
                // 時間帯リストを絞り込み結果で更新
                if (response.data && response.data.hopeTimeList) {
                    // カート分割時：TDK_HAISOU_LIST 内を TDK_SEQ + TDK_NO で検索
                    var haisouInfo = null;
                    if (_this.sh045Init.tdkInfo) {
                        for (var ti = 0; ti < _this.sh045Init.tdkInfo.length; ti++) {
                            var haisouList = _this.sh045Init.tdkInfo[ti].TDK_HAISOU_LIST;
                            if (haisouList) {
                                var found = haisouList.find(function(h) {
                                    return String(h['TDK_SEQ']) === tdkSeq && String(h['TDK_NO']) === tdkNo;
                                });
                                if (found) { haisouInfo = found; break; }
                            }
                        }
                    }
                    if (haisouInfo) {
                        _this.$set(haisouInfo, 'hopeTimeList', response.data.hopeTimeList);
                        // 現在選択中の時間帯が新リストに存在しない場合はクリア
                        var currentKbn = haisouInfo.hopeTdkTimeKbn || '';
                        var stillExists = response.data.hopeTimeList.some(function(item) { return item.KEY == currentKbn; });
                        if (!stillExists) {
                            _this.$set(haisouInfo, 'hopeTdkTimeKbn', '');
                        }
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },

        /*
        * 前のページへ戻るボタン押下処理
        */
        goBack: function() {
            var backPageNo = this.sh060.backPageNo || 28; // 戻り先ページNOが設定されていなければ、届先振り分け画面へ戻る
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: { pageNo: backPageNo } });
        },

        /*
        * 次へボタン押下処理
        */
        doConfirmSubmit: function() {
            var _this = this;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH045_PART);

            // ① リクエスト構築（カート分割有無を内部で吸収）
            _this.buildSubmitRequest();

            // ② フロントバリデーション（カート分割時のみ）
            if (!_this.validateFront()) {
                _this.$emit("event-loading", false);
                return;
            }

            // ③ 販売数チェック or 直接送信
            if (_this.sh045Init.displayHanbaiSuuFlg != 0) {
                _this.checkHanbaiSuu();
            } else {
                _this.execUpdate();
            }
        },

        /*
        * リクエスト構築（カート分割有無に応じてsh045Requestにセット）
        */
        buildSubmitRequest: function() {
            var _this = this;
            if (_this.sh045Init.cartSplitUseFlg == 1 && _this.sh045Init.tdkInfo) {
                // カート分割時：各配送単位のギフトデータをリクエストに含める
                var tdkGiftSettingList = [];
                for (var ti = 0; ti < _this.sh045Init.tdkInfo.length; ti++) {
                    var haisouList = _this.sh045Init.tdkInfo[ti].TDK_HAISOU_LIST;
                    if (haisouList) {
                        for (var hi = 0; hi < haisouList.length; hi++) {
                            var info = haisouList[hi];
                            var setting = {
                                tdkIndex: ti,
                                haisouIndex: hi,
                                tdkNo: info['TDK_NO'],
                                tdkSeq: info['TDK_SEQ'],
                                hopeTdkYmd: info['hopeTdkYmd'] || '',
                                hopeTdkYmdAfter: info['hopeTdkYmdAfter'] || '',
                                hopeTdkTimeKbn: info['hopeTdkTimeKbn'] || '',
                                updChakubiKbn: (info['radioGroup1'] == 1) ? '0' : (info['radioGroup1'] == 2) ? '1' : (info['radioGroup1'] == 3) ? '2' : '0',
                                pickupYmd: info['pickupYmd'] || '',
                                noshiUseFlg: (_this.sh045Init.nosiFlg == 1 || _this.sh045Init.housoushiFlg == 1 || _this.sh045Init.noshiNaireFlg == 1) ? 1 : 0,
                                housouKbn: info['housouKbn'] || '',
                                housouKbnNm: info['housouKbnNm'] || '',
                                ecoHousouMode: info['ecoHousouMode'] || '1',
                                noshiCd: info['noshiCd'] || '',
                                noshiSizeKbn: info['noshiSizeKbn'] || '',
                                mizuHikiKbn: info['mizuHikiKbn'] || '',
                                wappingKbn: info['wappingKbn'] || '',
                                omoteGaki1: info['omoteGaki1'] || '',
                                omoteGaki2: info['omoteGaki2'] || '',
                                omoteGaki3: info['omoteGaki3'] || '',
                                meimeiNm: info['meimeiNm'] || '',
                                compNm: info['compNm'] || '',
                                compKatagaki: info['compKatagaki'] || '',
                                syubetu: info['syubetu'] || '1',
                                simeiSei1: info['simeiSei1'] || '',
                                simeiSei2: info['simeiSei2'] || '',
                                simeiSei3: info['simeiSei3'] || '',
                                simeiSei4: info['simeiSei4'] || '',
                                simeiSei5: info['simeiSei5'] || '',
                                simeiMei1: info['simeiMei1'] || '',
                                simeiMei2: info['simeiMei2'] || '',
                                simeiMei3: info['simeiMei3'] || '',
                                simeiMei4: info['simeiMei4'] || '',
                                simeiMei5: info['simeiMei5'] || '',
                                namae1: info['namae1'] || '',
                                namae2: info['namae2'] || '',
                                namae3: info['namae3'] || '',
                                rubi1: info['rubi1'] || '',
                                rubi2: info['rubi2'] || '',
                                rubi3: info['rubi3'] || '',
                                compSyubetuCd: info['compSyubetuCd'] || '',
                                compSyubetuNm: info['compSyubetuNm'] || '',
                                compNm1: info['compNm'] || '',
                                compBusyo1: info['compBusyo1'] || '',
                                compBusyo2: info['compBusyo2'] || '',
                                compKatagaki1: info['compKatagaki'] || '',
                                compKojinNm1: info['compKojinNm1'] || '',
                                compKojinNm2: info['compKojinNm2'] || '',
                                noshiOkFlg: info['noshiOkFlg'] || 0,
                                housouOkFlg: info['housouOkFlg'] || 0,
                                noshiOkCheckFlg: 1,
                                doukonHinFlg: Number(info['doukonHinFlg'] || 0),
                                msgLabel: info['msgLabel'] || ''
                            };
                            tdkGiftSettingList.push(setting);
                        }
                    }
                }
                _this.sh045Request.tdkGiftSettingList = tdkGiftSettingList;
            } else if (_this.sh045Init.cartSplitUseFlg != 1 && _this.sh045Init.tdkInfo) {
                // 非カート分割時：各届先の配達希望日・希望時間帯をリクエストに含める
                var tdkYmdSettingList = [];
                for (var nsi = 0; nsi < _this.sh045Init.tdkInfo.length; nsi++) {
                    var nsTdk = _this.sh045Init.tdkInfo[nsi];
                    var radioVal = nsTdk.radioGroup1;
                    tdkYmdSettingList.push({
                        tdkSeq: nsTdk['TDK_SEQ'] != null ? String(nsTdk['TDK_SEQ']) : '',
                        tdkNo: nsTdk['TDK_NO'] != null ? String(nsTdk['TDK_NO']) : '0',
                        hopeTdkYmd: (radioVal == 2) ? (nsTdk.hopeTdkYmd || '') : '',
                        hopeTdkTimeKbn: nsTdk.hopeTdkTimeKbn || '',
                        updChakubiKbn: (radioVal == 2) ? '1' : '0',
                        sagyoKanriKomokuCd: nsTdk.sagyoKanriKomokuCd || '',
                        sagyoKanriKomokuCd2: nsTdk.sagyoKanriKomokuCd2 || '',
                        noshiNaire1: nsTdk.noshiNaire1 || '',
                        noshiNaire2: nsTdk.noshiNaire2 || ''
                    });
                }
                _this.sh045Request.tdkYmdSettingList = tdkYmdSettingList;
            }
        },

        /*
        * フロントバリデーション（カート分割時のみ：時間帯・着日 必須/指定不可チェック）
        * @return {boolean} エラーなし true / エラーあり false
        */
        validateFront: function() {
            var _this = this;
            var validErrList = [];

            if (_this.sh045Init.cartSplitUseFlg != 1) {
                // ---- 非カート分割時のバリデーション ----
                if (_this.sh045Init.tdkInfo && _this.sh045Init.tdkkibouFlg == 1) {
                    for (var i = 0; i < _this.sh045Init.tdkInfo.length; i++) {
                        var tdk = _this.sh045Init.tdkInfo[i];
                        var label = 'お届け先' + (i + 1) + '：';

                        // ---- 着日チェック ----
                        var ymdHissuFlg = String(tdk['TDK_YMD_HISSU_FLG'] || '');
                        var ymdErrFlg   = String(tdk['TDK_YMD_ERR_FLG'] || '');
                        var hanbaiFlg   = tdk['HANBAI_SUU_FLG'];
                        var hopeTdkYmd  = tdk['hopeTdkYmd'];
                        var ymdEmpty    = (hopeTdkYmd == null || hopeTdkYmd === '' || hopeTdkYmd == undefined);
                        // 着日必須：（必須フラグ または 販売数設定あり）&& 指定可 && 未選択
                        if ((ymdHissuFlg === '1' || hanbaiFlg == 1) && ymdErrFlg !== '1' && ymdEmpty) {
                            validErrList.push(label + 'お届け希望日を指定してください。');
                            var idYmd = 'sh045_hopeTdkYmd_' + i;
                            $('.' + _this.SH045_PART + ' #' + idYmd).css('border-color', 'red');
                            _this.listIdErr.push(idYmd);
                        }
                    }
                }
            } else {
                // ---- カート分割時のバリデーション ----
                if (_this.sh045Init.tdkInfo) {
                    for (var vti = 0; vti < _this.sh045Init.tdkInfo.length; vti++) {
                        var vHaisouList = _this.sh045Init.tdkInfo[vti].TDK_HAISOU_LIST;
                        if (!vHaisouList) continue;
                        for (var vhi = 0; vhi < vHaisouList.length; vhi++) {
                            var vInfo = vHaisouList[vhi];
                            var label = vInfo['msgLabel'];

                            // ---- 時間帯チェック ----
                            var tdkHmsDispFlg = String(vInfo['TDK_HMS_DISP_FLG'] != null ? vInfo['TDK_HMS_DISP_FLG'] : '0');
                            var tdkHstmHissuFlg = String((vInfo['TDK_ITEM_LIST'] && vInfo['TDK_ITEM_LIST'][0]) ? vInfo['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG'] || '' : '');
                            var tdkHmsSetNgFlg = String(vInfo['TDK_HMS_SET_NG_FLG'] || '');
                            var hopeTdkTimeKbn = vInfo['hopeTdkTimeKbn'];
                            var timeKbnEmpty = (hopeTdkTimeKbn == null || hopeTdkTimeKbn === '' || hopeTdkTimeKbn == undefined || hopeTdkTimeKbn === '0');
                            // 時間帯必須：表示あり && 必須 && 指定可 && 未選択
                            if (tdkHmsDispFlg === '1' && tdkHstmHissuFlg === '1' && tdkHmsSetNgFlg !== '1' && timeKbnEmpty) {
                                validErrList.push(label + '希望時間を指定してください。');
                                var idTime = 'sh045_hopeTdkTimeKbn_' + vti + '_' + vhi;
                                $('.' + _this.SH045_PART + ' #' + idTime).css('border-color', 'red');
                                _this.listIdErr.push(idTime);
                            }
                            // 時間帯指定不可：表示あり && 指定不可 && なのに選択されている
                            if (tdkHmsDispFlg === '1' && tdkHmsSetNgFlg === '1' && !timeKbnEmpty) {
                                validErrList.push(label + '希望時間は指定できません。');
                                var idTimeNg = 'sh045_hopeTdkTimeKbn_' + vti + '_' + vhi;
                                $('.' + _this.SH045_PART + ' #' + idTimeNg).css('border-color', 'red');
                                _this.listIdErr.push(idTimeNg);
                            }

                            // ---- 着日チェック ----
                            var tdkYmdDispFlg = String(vInfo['TDK_YMD_DISP_FLG'] != null ? vInfo['TDK_YMD_DISP_FLG'] : '0');
                            var tdkYmdHissuFlg = String((vInfo['TDK_ITEM_LIST'] && vInfo['TDK_ITEM_LIST'][0]) ? vInfo['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG'] || '' : '');
                            var tdkYmdSetNgFlg = String(vInfo['TDK_YMD_SET_NG_FLG'] || '');
                            var binsyuKbn = String(_this.sh045Init.tdkInfo[vti]['BINSYU_KBN'] || '');
                            var hopeTdkYmd = vInfo['hopeTdkYmd'];
                            var hopeTdkYmdAfter = vInfo['hopeTdkYmdAfter'];
                            var pickupYmd = vInfo['pickupYmd'];
                            var ymdEmpty;
                            if (binsyuKbn === '90') {
                                // 店頭受取の場合は受取日(pickupYmd)をチェック
                                ymdEmpty = (pickupYmd == null || pickupYmd === '' || pickupYmd == undefined);
                            } else {
                                ymdEmpty = ((hopeTdkYmd == null || hopeTdkYmd === '' || hopeTdkYmd == undefined)
                                         && (hopeTdkYmdAfter == null || hopeTdkYmdAfter === '' || hopeTdkYmdAfter == undefined));
                            }
                            // 着日必須：表示あり && 必須 && 指定可 && 未入力
                            if (tdkYmdDispFlg === '1' && tdkYmdHissuFlg === '1' && tdkYmdSetNgFlg !== '1' && ymdEmpty) {
                                validErrList.push(label + 'お届け希望日を指定してください。');
                                var idYmd = 'sh045_hopeTdkYmd_' + vti + '_' + vhi;
                                var idYmdAfter = 'sh045_hopeTdkYmdAfter_' + vti + '_' + vhi;
                                $('.' + _this.SH045_PART + ' #' + idYmd).css('border-color', 'red');
                                $('.' + _this.SH045_PART + ' #' + idYmdAfter).css('border-color', 'red');
                                _this.listIdErr.push(idYmd);
                                _this.listIdErr.push(idYmdAfter);
                            }
                            // 着日指定不可：表示あり && 指定不可 && なのに日付が入力されている
                            if (tdkYmdDispFlg === '1' && tdkYmdSetNgFlg === '1' && !ymdEmpty) {
                                validErrList.push(label + 'お届け希望日は指定できません。');
                                var idYmdNg = 'sh045_hopeTdkYmd_' + vti + '_' + vhi;
                                var idYmdAfterNg = 'sh045_hopeTdkYmdAfter_' + vti + '_' + vhi;
                                $('.' + _this.SH045_PART + ' #' + idYmdNg).css('border-color', 'red');
                                $('.' + _this.SH045_PART + ' #' + idYmdAfterNg).css('border-color', 'red');
                                _this.listIdErr.push(idYmdNg);
                                _this.listIdErr.push(idYmdAfterNg);
                            }
                        }
                    }
                }
            }

            if (validErrList.length > 0) {
                _this.listMessValid = validErrList;
                common.scrollTop();
                return false;
            }
            return true;
        },

        /*
        * 販売数チェック（displayHanbaiSuuFlg != 0 の場合）
        * チェックOK後に execUpdate() を呼ぶ
        */
        checkHanbaiSuu: function() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + '/doCheckHanbaiSuu', _this.sh045Request).then(function(checkRes) {
                if (checkRes.data.status == 'NG') {
                    // 配送単位別に messages をセット（TDK_SEQ + TDK_NO で照合）
                    var haisouMsgList = checkRes.data.haisouMessageList || [];
                    var firstErrTdkSeq = null;
                    if (_this.sh045Init.tdkInfo) {
                        for (var ti = 0; ti < _this.sh045Init.tdkInfo.length; ti++) {
                            var haisouList = _this.sh045Init.tdkInfo[ti]['TDK_HAISOU_LIST'];
                            if (_this.sh045Init.cartSplitUseFlg == 1 && haisouList) {
                                // カート分割時：配送単位単位でメッセージをセット
                                for (var hi = 0; hi < haisouList.length; hi++) {
                                    var haisou = haisouList[hi];
                                    var tdkSeq = String(haisou['TDK_SEQ'] != null ? haisou['TDK_SEQ'] : '');
                                    var tdkNo = String(haisou['TDK_NO'] != null ? haisou['TDK_NO'] : '');
                                    var found = null;
                                    for (var mi = 0; mi < haisouMsgList.length; mi++) {
                                        if (String(haisouMsgList[mi].tdkSeq) === tdkSeq && String(haisouMsgList[mi].tdkNo) === tdkNo) {
                                            found = haisouMsgList[mi];
                                            break;
                                        }
                                    }
                                    _this.$set(haisou, 'messages', found && found.messages ? found.messages : []);
                                    if (firstErrTdkSeq === null && found && found.messages && found.messages.length) {
                                        firstErrTdkSeq = tdkSeq;
                                    }
                                }
                            } else if (_this.sh045Init.cartSplitUseFlg != 1) {
                                // 非カート分割時：届先単位でメッセージをセット
                                var tdk = _this.sh045Init.tdkInfo[ti];
                                var tdkSeq = String(tdk['TDK_SEQ'] != null ? tdk['TDK_SEQ'] : '');
                                var tdkNo = String(tdk['TDK_NO'] != null ? tdk['TDK_NO'] : '');
                                var found = null;
                                for (var mi = 0; mi < haisouMsgList.length; mi++) {
                                    if (String(haisouMsgList[mi].tdkSeq) === tdkSeq && String(haisouMsgList[mi].tdkNo) === tdkNo) {
                                        found = haisouMsgList[mi];
                                        break;
                                    }
                                }
                                _this.$set(tdk, 'messages', found && found.messages ? found.messages : []);
                                if (firstErrTdkSeq === null && found && found.messages && found.messages.length) {
                                    firstErrTdkSeq = tdkSeq;
                                }
                            }
                        }
                    }
                    _this.$emit("event-loading", false);
                    _this.$forceUpdate();
                    _this.$nextTick(function() {
                        if (firstErrTdkSeq !== null) {
                            var target = document.getElementById('tdkYmdScroll_' + firstErrTdkSeq);
                            if (target) {
                                target.scrollIntoView();
                                return;
                            }
                        }
                        common.scrollTop();
                    });
                    return;
                }
                // チェックOK → messages をクリアして送信
                if (_this.sh045Init.tdkInfo) {
                    for (var ti = 0; ti < _this.sh045Init.tdkInfo.length; ti++) {
                        var haisouList = _this.sh045Init.tdkInfo[ti]['TDK_HAISOU_LIST'];
                        if (_this.sh045Init.cartSplitUseFlg == 1 && haisouList) {
                            for (var hi = 0; hi < haisouList.length; hi++) {
                                _this.$set(haisouList[hi], 'messages', []);
                            }
                        } else if (_this.sh045Init.cartSplitUseFlg != 1) {
                            _this.$set(_this.sh045Init.tdkInfo[ti], 'messages', []);
                        }
                    }
                }
                _this.execUpdate();
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },

        /*
        * DO_UPDATE 送信 + 画面遷移
        */
        execUpdate: function() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + _this.$UrlConstants.DO_UPDATE, _this.sh045Request).then(function(response) {
                if (response.data.status == "OK") {
                    if (_this.sh045Init.kokyakuNo == 999999999 || _this.sh045Init.stepBasedFlg == 1) {
                        // ゲスト購入の場合、またはステップ型遷移の場合
                        if (_this.sh045Init.paySkipFlg == 1 || _this.sh060.backPageNo == 22) {
                            // 支払方法割愛オプション有 or 注文確認画面から遷移した場合は、注文内容確認画面へ
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 22, actionId: 1 } });
                        } else {
                            // 支払方法確認画面へ
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 21, backPageNo: 24 } });
                        }
                    } else {
                        // 会員ログイン時は、注文内容確認画面へ
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 22 } });
                    }
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if (error != null && error != undefined) {
                    _this.isModalShow = false;
                    if (error.response != null && error.response != undefined) {
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.SH045_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },

        /*
        * 注文内容確認画面でどの「変更」リンクをクリックしたかによって、スクロールさせる
        */
        scroll: function() {
            var eleId;
            switch (this.scrollId) {
                case '1':
                    // 配送希望日時
                    eleId = 'tdkYmdScroll_' + this.tdkSeq;
                    break;
                case '2':
                    // ギフト設定
                    eleId = 'tdkGiftScroll_' + this.tdkSeq;
                    break;
                default:
                    eleId = '';
                    break;
            }
            if (eleId) {
                var element = document.getElementById(eleId);
                if (element != null) {
                    element.scrollIntoView();
                }
            }
        },

        /*
        * Function stringNvl
        */
        stringNvl: function(item, def) {
            if (item == null || item == undefined) {
                return def;
            }
            return item;
        },

        formatPrice: function(value) {
            return common.formatPrice(value);
        },

        /*
        * エラーメッセージ表示
        */
        displayWarning(errorList) {
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            if (errorList != null && errorList.length > 0) {
                for (var index = 0; index < errorList.length; index++) {
                    var listGroupId = errorList[index].groupId;
                    if (listGroupId != null && listGroupId.length > 0) {
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++) {
                            listIdErr.push(listGroupId[keyInx]);
                        }
                    }
                    var messageList = errorList[index].messageList;
                    if (messageList != null && messageList.length > 0) {
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++) {
                            var msgTemp = messageList[mesInx].message;
                            if (listGroupId != null && listGroupId.length > 0) {
                                var obj = {};
                                obj.key = listGroupId[0];
                                obj.mess = msgTemp;
                                mapMsg.push(obj);
                            } else {
                                msgList.push(msgTemp);
                            }
                        }
                    }
                }
                var msg = {};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        },

        // 包装区分変更
        housouKbnChangeInline: function(info) {
            var _this = this;
            // フィールドクリア
            info['noshiCd'] = '';
            info['noshiSizeKbn'] = '';
            info['mizuHikiKbn'] = '';
            info['wappingKbn'] = '';
            info['omoteGaki1'] = '';
            info['omoteGaki2'] = '';
            info['omoteGaki3'] = '';
            info['compSyubetuNm'] = '';
            info['meimeiNm'] = '';
            info['compNm'] = '';
            info['compKatagaki'] = '';
            info['doukonHinFlg'] = 0;

            // エコ包装判定
            var housouKbnItem = null;
            if (_this.sh045Init.housouKbnList != null) {
                housouKbnItem = _this.sh045Init.housouKbnList.find(item => item.SAGYO_CD === info['housouKbn']);
            }
            if (housouKbnItem != null && housouKbnItem.SAGYO_NM) {
                if (_this.sh045Init.ecoHousouLst != null && _this.sh045Init.ecoHousouLst.length > 0 && _this.sh045Init.ecoHousouLst.includes(housouKbnItem.SAGYO_CD)) {
                    _this.$set(info, 'ecoHousouMode', '1');
                } else if (_this.sh045Init.ecoHousouLst != null && _this.sh045Init.ecoHousouLst.length > 0) {
                    // エコ包装の梱包作業指示コード(13656)使用ありかつエコ包装リストに含まれないので完全包装
                    _this.$set(info, 'ecoHousouMode', '0');
                } else {
                    // エコ包装の梱包作業指示コード(13656)未使用の場合はエコ包装モード扱い
                    _this.$set(info, 'ecoHousouMode', '1');
                }
                info['housouKbnNm'] = housouKbnItem.SAGYO_NM;
            } else {
                _this.$set(info, 'ecoHousouMode', '1');
                info['housouKbnNm'] = '';
            }

            // のし初期値設定
            if (info['ecoHousouMode'] == '1') {
                if (_this.sh045Init.noshiCdList != null && _this.sh045Init.noshiCdList.length > 0) {
                    info['noshiCd'] = _this.sh045Init.noshiCdList[0].SAGYO_CD;
                }
            } else {
                if (_this.sh045Init.noshiCdList1 != null && _this.sh045Init.noshiCdList1.length > 0) {
                    info['noshiCd'] = _this.sh045Init.noshiCdList1[0].SAGYO_CD;
                }
            }

            // 完全包装の場合のみ、のしCd変更処理を呼ぶ
            if (info['ecoHousouMode'] == '0') {
                _this.noshiCdChangeInline(info, info['noshiCd']);
            }
            _this.$forceUpdate();
        },

        // のしコード変更（完全包装時）
        noshiCdChangeInline: function(info, value) {
            var _this = this;
            var noshiList1 = _this.sh045Init.noshiCdList1;
            var mujiNoshiCd = '';
            var mujiNoshiObj = noshiList1 ? noshiList1.find(el => el['VALUE'] === '無地のし') : null;
            mujiNoshiCd = mujiNoshiObj ? mujiNoshiObj['KEY'] : '';

            if (noshiList1) {
                for (var i = 0; i < noshiList1.length; i++) {
                    if (noshiList1[i].SAGYO_CD == value) {
                        if (mujiNoshiCd == value) {
                            info['omoteGaki1'] = '';
                            info['simeiSei1'] = '';
                        } else {
                            info['omoteGaki1'] = noshiList1[i].OMOTEGAKI;
                            if (!info['simeiSei1']) {
                                info['simeiSei1'] = info['kokyakuNm1'] || '';
                            }
                        }
                        info['mizuHikiKbn'] = noshiList1[i].MIZUHIKI_KBN;
                        info['wappingKbn'] = noshiList1[i].WRAPPING_KBN;
                    }
                }
            }
            // のしサイズリストの取得
            _this.fetchNoshiSizeListInline(info);
        },

        // のしサイズリスト取得（Ajax）
        fetchNoshiSizeListInline: function(info) {
            var _this = this;
            var ajaxReqModel = { noshiCd: info['noshiCd'] };
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH045 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(response) {
                _this.$set(info, 'noshiSizeList', response.data.noshiSizeList);
                info['noshiSizeKbn'] = '';

                // のしCDより水引区分の初期値
                var noshiList1 = _this.sh045Init.noshiCdList1;
                if (noshiList1) {
                    for (var i = 0; i < noshiList1.length; i++) {
                        if (noshiList1[i].SAGYO_CD == info['noshiCd']) {
                            info['mizuHikiKbn'] = noshiList1[i].MIZUHIKI_KBN;
                            break;
                        }
                    }
                }
                // のしサイズ初期値を算出してセット
                _this.calcNoshiSizeKbn(info);
                _this.$forceUpdate();
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },

        // のしサイズ区分の算出・セット
        // noshiSizeList と mizuHikiKbn・NOSHI_SIZE_KBN をもとに info['noshiSizeKbn'] を決定する
        calcNoshiSizeKbn: function(info) {
            var _this = this;
            if (!info['noshiSizeList'] || info['noshiSizeList'].length == 0) {
                return;
            }
            // 水引区分に対応する PARAM_MARK（デフォルトのしサイズ）を取得
            var mizuHikiKbnParam = '';
            if (_this.sh045Init.mizuHikiKbnList) {
                for (var j = 0; j < _this.sh045Init.mizuHikiKbnList.length; j++) {
                    if (_this.sh045Init.mizuHikiKbnList[j].KEY == info['mizuHikiKbn']) {
                        mizuHikiKbnParam = _this.sh045Init.mizuHikiKbnList[j].PARAM_MARK;
                        break;
                    }
                }
            }
            // 商品マスタのしサイズ区分（優先）
            var itemNoshiSizeKbn = (info['TDK_ITEM_LIST'] && info['TDK_ITEM_LIST'][0]) ? info['TDK_ITEM_LIST'][0]['NOSHI_SIZE_KBN'] : null;
            var defult = info['noshiSizeList'][0].KEY;
            for (var k = 0; k < info['noshiSizeList'].length; k++) {
                var item = info['noshiSizeList'][k];
                if (item != undefined && !common.isNullItem(item.KEY) && !common.isNullItem(itemNoshiSizeKbn) && item.KEY == itemNoshiSizeKbn) {
                    defult = item.KEY;
                    break;
                } else {
                    if (item != undefined && !common.isNullItem(item.KEY) && item.KEY == mizuHikiKbnParam) {
                        defult = mizuHikiKbnParam;
                    }
                }
            }
            info['noshiSizeKbn'] = defult;
        },

        // 水引区分変更
        mizuHikiKbnChangeInline: function(info) {
            var _this = this;
            var itemNoshiSizeKbn = (info['TDK_ITEM_LIST'] && info['TDK_ITEM_LIST'][0]) ? info['TDK_ITEM_LIST'][0]['NOSHI_SIZE_KBN'] : null;
            if (!common.isNullItem(itemNoshiSizeKbn)) {
                return;
            }
            if (_this.sh045Init.mizuHikiKbnList) {
                for (var i = 0; i < _this.sh045Init.mizuHikiKbnList.length; i++) {
                    if (_this.sh045Init.mizuHikiKbnList[i].KEY == info['mizuHikiKbn']) {
                        var defaultVal = _this.sh045Init.mizuHikiKbnList[i].PARAM_MARK;
                        if (!common.isNullItem(defaultVal) && info['noshiSizeList']) {
                            var defult = info['noshiSizeList'][0].KEY;
                            for (var j = 0; j < info['noshiSizeList'].length; j++) {
                                var item = info['noshiSizeList'][j];
                                if (item != undefined && !common.isNullItem(item.KEY) && item.KEY == defaultVal) {
                                    defult = defaultVal;
                                    break;
                                }
                            }
                            info['noshiSizeKbn'] = defult;
                        }
                        break;
                    }
                }
            }
            _this.$forceUpdate();
        },

        // 種別変更
        syubetuChangedInline: function(info) {
            if (info['syubetu'] == '1') {
                info['simeiSei2'] = '';
                info['simeiSei3'] = '';
                info['simeiSei4'] = '';
                info['simeiSei5'] = '';
                info['simeiMei2'] = '';
                info['simeiMei3'] = '';
                info['simeiMei4'] = '';
                info['simeiMei5'] = '';
            }
            if (info['syubetu'] == '2') {
                info['simeiSei2'] = '';
                info['simeiSei3'] = '';
                info['simeiSei4'] = '';
                info['simeiSei5'] = '';
            }
            if (info['syubetu'] == '5') {
                if (!info['compSyubetuCd']) {
                    info['compSyubetuCd'] = '1';
                }
            }
            this.$forceUpdate();
        },

        // 会社種別ドロップダウン変更
        compSyubetuChangeInline: function(info, e) {
            var value = e.target.value;
            var itemList = this.sh045Init.compKindList;
            if (itemList) {
                for (var i = 0; i < itemList.length; i++) {
                    if (itemList[i].KEY == value) {
                        info['compSyubetuNm'] = itemList[i].VALUE;
                        this.$forceUpdate();
                    }
                }
            }
        },

        // 肩書ドロップダウン変更
        compKatagakiChangeInline: function(info, e) {
            var value = e.target.value;
            var itemList = this.sh045Init.compKatagakiList;
            if (itemList) {
                for (var i = 0; i < itemList.length; i++) {
                    if (itemList[i].KEY == value) {
                        info['compKatagaki'] = itemList[i].VALUE;
                        this.$forceUpdate();
                    }
                }
            }
        },

        // ギフトデータ初期化（doSetItem相当）
        initHaisouGiftData: function(info) {
            var _this = this;
            // ギフト設定デフォルト

            // エコ包装設定
            if (!info['housouKbn']) {
                var defaultHousouItem = null;
                if (_this.sh045Init.ecoHousouLst != null) {
                    if (_this.sh045Init.housouKbnList != null) {
                        defaultHousouItem = _this.sh045Init.housouKbnList.find(item => _this.sh045Init.ecoHousouLst.includes(item.SAGYO_CD));
                    }
                }
                if (defaultHousouItem != null && defaultHousouItem.SAGYO_CD) {
                    info['housouKbn'] = defaultHousouItem.SAGYO_CD;
                    info['housouKbnNm'] = defaultHousouItem.SAGYO_NM;
                    _this.$set(info, 'ecoHousouMode', '1');
                } else {
                    // housoushiFlg==1のときのみ包装区分を自動設定する
                    if (_this.sh045Init.housoushiFlg == 1 && _this.sh045Init.housouKbnList != null && _this.sh045Init.housouKbnList.length > 0) {
                        info['housouKbn'] = _this.sh045Init.housouKbnList[0].SAGYO_CD;
                        info['housouKbnNm'] = _this.sh045Init.housouKbnList[0].SAGYO_NM;
                    } else {
                        info['housouKbn'] = '';
                        info['housouKbnNm'] = '';
                    }
                    // エコ包装の梱包作業指示コード(13656)未使用(ecoHousouLstがnull/空)の場合はエコ包装モード扱い
                    // サーバー側でmeimeiNm/compNm/compKatagakiを保存するためecoHousouMode='1'とする
                    if (_this.sh045Init.ecoHousouLst == null || _this.sh045Init.ecoHousouLst.length == 0) {
                        _this.$set(info, 'ecoHousouMode', '1');
                    } else {
                        _this.$set(info, 'ecoHousouMode', '0');
                    }
                }
            } else {
                if (_this.sh045Init.ecoHousouLst != null && _this.sh045Init.ecoHousouLst.length > 0 && _this.sh045Init.ecoHousouLst.includes(info['housouKbn'])) {
                    _this.$set(info, 'ecoHousouMode', '1');
                } else if (_this.sh045Init.ecoHousouLst != null && _this.sh045Init.ecoHousouLst.length > 0) {
                    _this.$set(info, 'ecoHousouMode', '0');
                } else {
                    // エコ包装の梱包作業指示コード(13656)未使用の場合はエコ包装モード扱い
                    _this.$set(info, 'ecoHousouMode', '1');
                }
                var foundHousou = _this.sh045Init.housouKbnList ? _this.sh045Init.housouKbnList.find(el => el['SAGYO_CD'] === info['housouKbn']) : null;
                if (foundHousou) {
                    info['housouKbnNm'] = foundHousou['SAGYO_NM'];
                }
            }

            // のし初期設定
            // エコ包装の梱包作業指示コード(13656)未使用(ecoHousouLstがnull/空) または エコ包装モード(ecoHousouMode=='1') の場合はnoshiCdListを使用
            // エコ包装の梱包作業指示コード(13656)使用かつ完全包装モード(ecoHousouMode=='0') の場合はnoshiCdList1を使用
            var useEcoNoshiList = (_this.sh045Init.ecoHousouLst == null || _this.sh045Init.ecoHousouLst.length == 0 || info['ecoHousouMode'] == '1');
            if (!info['noshiCd']) {
                if (useEcoNoshiList && _this.sh045Init.noshiCdList && _this.sh045Init.noshiCdList.length > 0) {
                    info['noshiCd'] = _this.sh045Init.noshiCdList[0].SAGYO_CD;
                } else {
                    info['noshiCd'] = '';
                }
            } else {
                var defaultnoshiCd = null;
                if (useEcoNoshiList) {
                    defaultnoshiCd = _this.sh045Init.noshiCdList ? _this.sh045Init.noshiCdList.find(el => el['SAGYO_CD'] === info['noshiCd']) : null;
                    if (defaultnoshiCd && defaultnoshiCd.SAGYO_CD) {
                        info['noshiCd'] = defaultnoshiCd.SAGYO_CD;
                    } else if (_this.sh045Init.noshiCdList && _this.sh045Init.noshiCdList.length > 0) {
                        info['noshiCd'] = _this.sh045Init.noshiCdList[0].SAGYO_CD;
                    }
                } else {
                    defaultnoshiCd = _this.sh045Init.noshiCdList1 ? _this.sh045Init.noshiCdList1.find(el => el['SAGYO_CD'] === info['noshiCd']) : null;
                    if (defaultnoshiCd && defaultnoshiCd.SAGYO_CD) {
                        info['noshiCd'] = defaultnoshiCd.SAGYO_CD;
                    } else if (_this.sh045Init.noshiCdList1 && _this.sh045Init.noshiCdList1.length > 0) {
                        info['noshiCd'] = _this.sh045Init.noshiCdList1[0].SAGYO_CD;
                    }
                }
            }

            // 包装可フラグ
            if (info['housouOkFlg'] != 1) {
                info['noshiCd'] = '';
            }

            // 商品マスタ着日区分（0:なし 1:のみ 2:以降）
            var itemChakubiKbn = (info['TDK_ITEM_LIST'] && info['TDK_ITEM_LIST'][0]) ? String(info['TDK_ITEM_LIST'][0]['CHAKUBI_KBN'] || '') : '';

            // 希望日・希望時間の初期化
            if (!info['hopeTdkYmd'] && !info['hopeTdkYmdAfter']) {
                // UPD_CHAKUBI_KBN：ユーザーが選択した着日区分（doUpdate時に保存）を優先
                // なければDB保存済みユーザー選択値（W_EA012_ORDERADDR.CHAKUBI_KBN）にフォールバック
                var updChakubiKbn = String(info['UPD_CHAKUBI_KBN'] != null && info['UPD_CHAKUBI_KBN'] !== '' ? info['UPD_CHAKUBI_KBN'] : (info['CHAKUBI_KBN'] || ''));
                if (_this.sh045Init.chakubiOption == 1 && (updChakubiKbn == '2' || itemChakubiKbn == '2')) {
                    // 以降指定の場合: hopeTdkYmdAfterにTDK_YMDをセット
                    info['hopeTdkYmdAfter'] = info['TDK_YMD'] || '';
                    info['hopeTdkYmd'] = '';
                } else {
                    info['hopeTdkYmd'] = info['TDK_YMD'] || '';
                    info['hopeTdkYmdAfter'] = '';
                }
            }
            if (!info['hopeTdkTimeKbn']) {
                info['hopeTdkTimeKbn'] = info['TDK_HMS_KBN'] || '';
            }
            // 受取の場合: pickupYmdを初期化
            if (String(info['BINSYU_KBN'] || '') == '90') {
                if (!info['pickupYmd']) {
                    info['pickupYmd'] = info['TDK_YMD'] || '';
                }
            }
            // radioGroup1の初期化
            var tdkYmdSetNgFlg = String(info['TDK_YMD_SET_NG_FLG'] || '');
            var tdkYmdHissuFlgItem = String((info['TDK_ITEM_LIST'] && info['TDK_ITEM_LIST'][0]) ? info['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG'] || '' : '');
            // UPD_CHAKUBI_KBN（ユーザー選択値）優先、なければDB保存済みユーザー選択値（W_EA012_ORDERADDR.CHAKUBI_KBN）にフォールバック
            var initChakubiKbn = String(info['UPD_CHAKUBI_KBN'] != null && info['UPD_CHAKUBI_KBN'] !== '' ? info['UPD_CHAKUBI_KBN'] : (info['CHAKUBI_KBN'] || ''));
            if (info['hopeTdkYmd']) {
                _this.$set(info, 'radioGroup1', 2); // のみ（日付指定）
            } else if (_this.sh045Init.chakubiOption == 1 && (info['hopeTdkYmdAfter'] || initChakubiKbn == '2')) {
                _this.$set(info, 'radioGroup1', 3); // 以降
            } else if (tdkYmdSetNgFlg == '1') {
                _this.$set(info, 'radioGroup1', 1); // 着日指定不可のため指定なし
            } else if (tdkYmdHissuFlgItem == '1') {
                // 商品マスタの着日区分(itemChakubiKbn)も確認：ユーザー保存値がなくても以降強制なら radioGroup1=3
                if (_this.sh045Init.chakubiOption == 1 && (initChakubiKbn == '2' || itemChakubiKbn == '2')) {
                    _this.$set(info, 'radioGroup1', 3); // 以降指定必須
                } else {
                    _this.$set(info, 'radioGroup1', 2); // のみ指定必須
                }
            } else {
                // 販売数設定有（在庫チェックリンク表示あり）の場合は「指定なし」を初期選択しない
                // → tdkYmdList の最初の選択可能日（index=1）を「日付指定」でプリセット
                if (_this.sh045Init.displayHanbaiSuuFlg != 0 && info['tdkYmdList'] && info['tdkYmdList'].length > 1) {
                    info['hopeTdkYmd'] = info['tdkYmdList'][1]['KEY'];
                    _this.$set(info, 'radioGroup1', 2);
                } else {
                    _this.$set(info, 'radioGroup1', 1); // 指定なし
                }
            }

            // 同梱品フラグ初期化
            if (info['doukonHinFlg'] == null || info['doukonHinFlg'] == undefined) {
                _this.$set(info, 'doukonHinFlg', String(info['DOUKON_HIN_FLG'] != null ? info['DOUKON_HIN_FLG'] : '0'));
            }

            // radioGroup1確定後にアイテム制御フラグを計算する
            _this.calcItemControl(info);
        },

        /**
         * 配送単位ごとのUI制御フラグを計算して info.itemControl にセットする。
         *
         * ・着日指定不可（TDK_YMD_SET_NG_FLG=1）の場合、「のみ」「以降」ラジオ・セレクトを無効化する。
         * ・着日必須（TDK_YMD_HISSU_FLG=1）の場合、「指定なし」ラジオを無効化し、
         *   着日区分（CHAKUBI_KBN）が 1(のみ) なら「のみ」のみ有効、2(以降) なら「以降」のみ有効とする。
         * ・時間指定不可（TDK_HMS_SET_NG_FLG=1）の場合、希望時間セレクトを無効化する。
         * ・商品マスタ着日区分（CHAKUBI_KBN）による上書き：
         *   1(のみ指定) → 「以降」ラジオ・セレクトを強制無効化
         *   2(以降指定) → 「のみ」ラジオ・セレクトを強制無効化
         */
        calcItemControl: function(info) {
            var _this = this;

            // フラグ値取得
            var tdkItem         = info['TDK_ITEM_LIST'] && info['TDK_ITEM_LIST'][0] ? info['TDK_ITEM_LIST'][0] : {};
            var tdkYmdHissuFlg  = parseInt(String(tdkItem['TDK_YMD_HISSU_FLG']  || 0)); // 着日必須フラグ
            var tdkYmdErrFlg    = parseInt(String(info['TDK_YMD_SET_NG_FLG']    || 0)); // 着日指定不可フラグ
            var tdkHstmHissuFlg = parseInt(String(tdkItem['TDK_HSTM_HISSU_FLG'] || 0)); // 時間必須フラグ
            var tdkHstmErrFlg   = parseInt(String(info['TDK_HMS_SET_NG_FLG']    || 0)); // 時間指定不可フラグ
            var chakubiKbn      = String(tdkItem['CHAKUBI_KBN'] || '');                 // 商品マスタ着日区分 0:なし 1:のみ 2:以降
            var chakubiOption   = _this.sh045Init.chakubiOption;

            // デフォルト：全て使用可能
            var ctl = {
                radioGrp1Flg: 1,    // 指定なし ラジオボタン
                radioGrp2Flg: 1,    // のみ ラジオボタン
                radioGrp3Flg: 1,    // 以降 ラジオボタン
                ymdHopeFlg:   1,    // のみ お届け希望日セレクト
                ymdAftFlg:    1,    // 以降 お届け希望日セレクト
                timeHopeFlg:  1,    // 希望時間セレクト
                pickupYmdFlg: 1     // 受取日セレクト
            };

            //1行目：全て正常 → デフォルトのまま
            //2行目：のみ（顧客指定付き）
            if (chakubiOption == 1 && chakubiKbn == 1 && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 0; ctl.ymdAftFlg    = 0;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 1;
            //3行目：以降（顧客指定無し）
            } else if (chakubiOption == 1 && chakubiKbn == 2 && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 0; ctl.ymdHopeFlg   = 0;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 1;
            //3行目-1：着日必須・着日区分なし
            } else if (chakubiOption == 1 && (chakubiKbn == '' || chakubiKbn == '0') && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 1;
            }
            //4行目：着日指定不可
            if (tdkYmdHissuFlg == 0 && tdkYmdErrFlg == 1 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 0; ctl.ymdHopeFlg   = 0;
                ctl.radioGrp3Flg = 0; ctl.ymdAftFlg    = 0;
                ctl.radioGrp1Flg = 1; ctl.timeHopeFlg  = 1;
            }
            //5行目：配達時間必須 → デフォルトのまま
            //6行目：のみ かつ 配達時間必須
            if (chakubiOption == 1 && chakubiKbn == 1 && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 1 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 0; ctl.ymdAftFlg    = 0;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 1;
            //7行目：以降 かつ 配達時間必須
            } else if (chakubiOption == 1 && chakubiKbn == 2 && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 1 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 0; ctl.ymdHopeFlg   = 0;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 1;
            //7行目-1：着日必須・着日区分なし かつ 配達時間必須
            } else if (chakubiOption == 1 && (chakubiKbn == '' || chakubiKbn == '0') && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 1 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 1;
            }
            //8行目：着日指定不可 かつ 配達時間必須
            if (tdkYmdHissuFlg == 0 && tdkYmdErrFlg == 1 && tdkHstmHissuFlg == 1 && tdkHstmErrFlg == 0) {
                ctl.radioGrp2Flg = 0; ctl.ymdHopeFlg   = 0;
                ctl.radioGrp3Flg = 0; ctl.ymdAftFlg    = 0;
                ctl.radioGrp1Flg = 1; ctl.timeHopeFlg  = 1;
            }
            //9行目：配達時間指定不可
            if (tdkYmdHissuFlg == 0 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 1) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 1; ctl.timeHopeFlg  = 0;
            }
            //10行目：のみ かつ 配達時間指定不可
            if (chakubiOption == 1 && chakubiKbn == 1 && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 1) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 0; ctl.ymdAftFlg    = 0;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 0;
            //11行目：以降 かつ 配達時間指定不可
            } else if (chakubiOption == 1 && chakubiKbn == 2 && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 1) {
                ctl.radioGrp2Flg = 0; ctl.ymdHopeFlg   = 0;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 0;
            //11行目-1：着日必須・着日区分なし かつ 配達時間指定不可
            } else if (chakubiOption == 1 && (chakubiKbn == '' || chakubiKbn == '0') && tdkYmdHissuFlg == 1 && tdkYmdErrFlg == 0 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 1) {
                ctl.radioGrp2Flg = 1; ctl.ymdHopeFlg   = 1;
                ctl.radioGrp3Flg = 1; ctl.ymdAftFlg    = 1;
                ctl.radioGrp1Flg = 0; ctl.timeHopeFlg  = 0;
            }
            //12行目：着日指定不可 かつ 配達時間指定不可
            if (tdkYmdHissuFlg == 0 && tdkYmdErrFlg == 1 && tdkHstmHissuFlg == 0 && tdkHstmErrFlg == 1) {
                ctl.radioGrp2Flg = 0; ctl.ymdHopeFlg   = 0;
                ctl.radioGrp3Flg = 0; ctl.ymdAftFlg    = 0;
                ctl.radioGrp1Flg = 1; ctl.timeHopeFlg  = 0;
            }
            // 着日オプション使用時：商品マスタの着日区分による上書き制御
            if (chakubiOption == 1) {
                if (chakubiKbn == 1) {
                    // のみを設定（商品マスタ）→ 以降を使用不可
                    ctl.radioGrp3Flg = 0;
                    ctl.ymdAftFlg    = 0;
                } else if (chakubiKbn == 2) {
                    // 以降を設定（商品マスタ）→ のみを使用不可
                    ctl.radioGrp2Flg = 0;
                    ctl.ymdHopeFlg   = 0;
                }
            }
            // 着日指定不可の場合は受取日（店頭受取）指定不可
            if (tdkYmdErrFlg == 1) {
                ctl.pickupYmdFlg = 0;
            }

            _this.$set(info, 'itemControl', ctl);
        },

        // 配送単位で指定するのしなどのギフト設定を全配送先分に反映する Confirm
        copyTdkGiftSettingConfirm: function(tdkSeq, tdkNo) {
            var _this = this;
            if (_this.sh045Init.cartSplitUseFlg == 1) {
                _this.outputMsgConfirm = _this.$i18n.t('sh060.messages.copyTdkGiftSettingMsg');
                _this.isShowGiftSettingCopyAlert = true;
                _this.copyRequestModel.tdkSeq = tdkSeq;
                _this.copyRequestModel.tdkNo = tdkNo;
                return false;
            }
        },

        // 配送単位で指定するのしなどのギフト設定を全配送先分に反映する
        doCopyTdkGiftSetting: function() {
            var _this = this;
            _this.isShowGiftSettingCopyAlert = false;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH045_PART);

            var srcTdkSeq = _this.copyRequestModel.tdkSeq;
            var srcTdkNo = _this.copyRequestModel.tdkNo;

            // コピー元haisouInfoを探す
            var srcInfo = null;
            outer:
            for (var ti = 0; ti < (_this.sh045Init.tdkInfo || []).length; ti++) {
                var hl = _this.sh045Init.tdkInfo[ti].TDK_HAISOU_LIST || [];
                for (var hi = 0; hi < hl.length; hi++) {
                    if (hl[hi]['TDK_SEQ'] == srcTdkSeq && hl[hi]['TDK_NO'] == srcTdkNo) {
                        srcInfo = hl[hi];
                        break outer;
                    }
                }
            }
            if (!srcInfo) return;

            var srcEcoHousouMode = String(srcInfo['ecoHousouMode'] || '0');
            // コピー元の日付・時間の有無（着日・時間コピー可否チェックに使用）
            var srcHasDate = !!(srcInfo['hopeTdkYmd'] || srcInfo['hopeTdkYmdAfter'] || srcInfo['pickupYmd']);
            var srcHasTime = !!(srcInfo['hopeTdkTimeKbn'] && srcInfo['hopeTdkTimeKbn'] !== '0');

            // コピー不可エラーメッセージ蓄積用
            var copyErrMsgs = [];

            // 各配送先にコピー
            for (var ti2 = 0; ti2 < (_this.sh045Init.tdkInfo || []).length; ti2++) {
                var destBinsyuKbn = String(_this.sh045Init.tdkInfo[ti2]['BINSYU_KBN'] || '');
                var destYmdLabel = destBinsyuKbn == '90' ? '受取日' : 'お届け希望日';
                var haisouList = _this.sh045Init.tdkInfo[ti2].TDK_HAISOU_LIST || [];
                for (var hi2 = 0; hi2 < haisouList.length; hi2++) {
                    var dest = haisouList[hi2];

                    // コピー元はスキップ
                    if (dest['TDK_SEQ'] == srcTdkSeq && dest['TDK_NO'] == srcTdkNo) {
                        continue;
                    }

                    // 包装・のし設定：コピー元が包装不可の場合はコピー先の値をそのまま保持する
                    // コピー元が包装可の場合のみコピー（またはクリア）を行う
                    if (srcInfo['housouOkFlg'] == 1) {
                        // のし設定フィールド一覧（全フィールドクリア用）
                        var noshiFields = [
                            'noshiCd', 'mizuHikiKbn', 'wappingKbn',
                            'omoteGaki1', 'omoteGaki2', 'omoteGaki3',
                            'syubetu',
                            'simeiSei1', 'simeiSei2', 'simeiSei3', 'simeiSei4', 'simeiSei5',
                            'simeiMei1', 'simeiMei2', 'simeiMei3', 'simeiMei4', 'simeiMei5',
                            'namae1', 'namae2', 'namae3',
                            'rubi1', 'rubi2', 'rubi3',
                            'meimeiNm', 'compNm', 'compKatagaki',
                            'compSyubetuCd', 'compSyubetuNm',
                            'compBusyo1', 'compBusyo2',
                            'compKojinNm1', 'compKojinNm2'
                        ];

                        if (dest['housouOkFlg'] == 1 && dest['noshiOkFlg'] == 1) {
                            // 【包装可・のし可】包装設定 + のし設定フルコピー
                            _this.$set(dest, 'housouKbn', srcInfo['housouKbn'] || '');
                            _this.$set(dest, 'housouKbnNm', srcInfo['housouKbnNm'] || '');
                            _this.$set(dest, 'ecoHousouMode', srcEcoHousouMode);
                            noshiFields.forEach(function(f) { _this.$set(dest, f, srcInfo[f] || ''); });
                            // noshiSizeKbn はコピーせず、コピー先の商品情報をもとに再算出する
                            _this.$set(dest, 'noshiSizeList', srcInfo['noshiSizeList'] ? srcInfo['noshiSizeList'].slice() : []);
                            _this.calcNoshiSizeKbn(dest);

                        } else if (dest['housouOkFlg'] == 1 && dest['noshiOkFlg'] != 1) {
                            // 【包装可・のし不可】エコ包装固定・名入れのみコピー可
                            // 包装設定（housouKbn等）・のし設定はコピーしない（コピー先の値を保持）
                            // コピー元がエコ包装の場合のみ、のしコードと名入れをコピーする
                            if (srcEcoHousouMode == '1') {
                                _this.$set(dest, 'noshiCd', srcInfo['noshiCd'] || '');
                                _this.$set(dest, 'meimeiNm', srcInfo['meimeiNm'] || '');
                                _this.$set(dest, 'compNm', srcInfo['compNm'] || '');
                                _this.$set(dest, 'compKatagaki', srcInfo['compKatagaki'] || '');
                            }

                        } else {
                            // 【包装不可】のし設定をクリア
                            noshiFields.forEach(function(f) { _this.$set(dest, f, ''); });
                        }
                    }

                    // 希望日のコピー(着日利用オプションが有効な場合)
                    if (_this.sh045Init.tdkkibouFlg == 1) {
                        // コピー先の着日制約チェック（店頭受取・通常配送共通）
                        var destYmdSetNgFlg = String(dest['TDK_YMD_SET_NG_FLG'] || '');
                        var destYmdHissuFlg = String((dest['TDK_ITEM_LIST'] && dest['TDK_ITEM_LIST'][0]) ? dest['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG'] || '' : '');
                        var canCopyDate = true;
                        var haisouLabel = dest['msgLabel'];
                        if (destYmdSetNgFlg == '1' && srcHasDate) {
                            canCopyDate = false;
                            copyErrMsgs.push(haisouLabel + destYmdLabel + 'は指定不可です。');
                        } else if (destYmdHissuFlg == '1' && !srcHasDate) {
                            canCopyDate = false;
                            copyErrMsgs.push(haisouLabel + destYmdLabel + 'は必須です。');
                        }
                        // コピー先プルダウンリストに存在しない日付はコピー不可
                        if (canCopyDate && srcHasDate && dest['tdkYmdList']) {
                            var dateToCheck = destBinsyuKbn == '90'
                                ? (srcInfo['pickupYmd'] || srcInfo['hopeTdkYmd'] || '')  // hopeTdkYmdAfter は着日区分チェックで除外するためここでは参照しない
                                : (srcInfo['hopeTdkYmd'] || srcInfo['pickupYmd'] || '');
                            if (dateToCheck) {
                                var foundDate = dest['tdkYmdList'].some(function(item) { return item.KEY == dateToCheck; });
                                if (!foundDate) {
                                    canCopyDate = false;
                                    copyErrMsgs.push(haisouLabel + '指定できない' + destYmdLabel + 'です。');
                                }
                            }
                        }
                        // 着日区分チェック：コピー先のitemControl（UI制御フラグ）で判定
                        // コピー先で使用不可になっている着日種別はコピーできない
                        if (canCopyDate && srcHasDate) {
                            if (destBinsyuKbn == '90') {
                                // 店頭受取の受取日は「のみ」に相当するため、コピー元が「以降」ならコピー不可
                                if (srcInfo['hopeTdkYmdAfter']) {
                                    canCopyDate = false;
                                    copyErrMsgs.push(haisouLabel + '「以降」の希望日は指定できません。');
                                }
                            } else {
                                var destCtl = dest['itemControl'];
                                if (destCtl) {
                                    // pickupYmd（店頭受取）は「のみ」相当として扱う
                                    var srcEffectiveYmd = srcInfo['hopeTdkYmd'] || srcInfo['pickupYmd'] || '';
                                    if (srcEffectiveYmd && destCtl.ymdHopeFlg != 1) {
                                        canCopyDate = false;
                                        copyErrMsgs.push(haisouLabel + '「お届け日指定」の希望日は指定できません。');
                                    } else if (srcInfo['hopeTdkYmdAfter'] && destCtl.ymdAftFlg != 1) {
                                        canCopyDate = false;
                                        copyErrMsgs.push(haisouLabel + '「以降」の希望日は指定できません。');
                                    }
                                }
                            }
                        }
                        if (canCopyDate) {
                            if (destBinsyuKbn == '90') {
                                // 店頭受取: pickupYmd にセット
                                // コピー元が通常配送の場合は hopeTdkYmd を代替参照（hopeTdkYmdAfter は着日区分チェックでブロック済み）
                                _this.$set(dest, 'pickupYmd', srcInfo['pickupYmd'] || srcInfo['hopeTdkYmd'] || '');
                            } else {
                                // 通常配送: hopeTdkYmd にセット
                                // コピー元が店頭受取の場合は pickupYmd を代替参照
                                _this.$set(dest, 'hopeTdkYmd', srcInfo['hopeTdkYmd'] || srcInfo['pickupYmd'] || '');
                                if (_this.sh045Init.chakubiOption == 1) {
                                    _this.$set(dest, 'hopeTdkYmdAfter', srcInfo['hopeTdkYmdAfter'] || '');
                                }
                            }
                        }

                        // radioGroup1の再計算（initHaisouGiftData と同じロジックを使用）
                        // 着日利用オプション有効時のみ実行する（tdkkibouFlg == 1）
                        var ymdSetNgFlg = String(dest['TDK_YMD_SET_NG_FLG'] || '');
                        var ymdHissuFlgItem = String((dest['TDK_ITEM_LIST'] && dest['TDK_ITEM_LIST'][0]) ? dest['TDK_ITEM_LIST'][0]['TDK_YMD_HISSU_FLG'] || '' : '');
                        // UPD_CHAKUBI_KBN（ユーザー選択値）優先、なければ CHAKUBI_KBN（DB保存値）を使用
                        var reCalcChakubiKbn = String(dest['UPD_CHAKUBI_KBN'] != null && dest['UPD_CHAKUBI_KBN'] !== '' ? dest['UPD_CHAKUBI_KBN'] : (dest['CHAKUBI_KBN'] || ''));
                        // 商品マスタの着日区分（initHaisouGiftData と同様に参照）
                        var itemChakubiKbnForCalc = String((dest['TDK_ITEM_LIST'] && dest['TDK_ITEM_LIST'][0]) ? dest['TDK_ITEM_LIST'][0]['CHAKUBI_KBN'] || '' : '');
                        var newRadioGroup1;
                        if (dest['hopeTdkYmd']) {
                            newRadioGroup1 = 2;
                        } else if (_this.sh045Init.chakubiOption == 1 && dest['hopeTdkYmdAfter']) {
                            newRadioGroup1 = 3;
                        } else if (ymdSetNgFlg == '1') {
                            newRadioGroup1 = 1;
                        } else if (ymdHissuFlgItem == '1') {
                            // initHaisouGiftData と同様に ユーザー保存値 OR 商品マスタ が「以降」なら radioGroup1=3
                            if (_this.sh045Init.chakubiOption == 1 && (reCalcChakubiKbn == '2' || itemChakubiKbnForCalc == '2')) {
                                newRadioGroup1 = 3;
                            } else {
                                newRadioGroup1 = 2;
                            }
                        } else {
                            newRadioGroup1 = 1;
                        }
                        _this.$set(dest, 'radioGroup1', newRadioGroup1);
                        // UPD_CHAKUBI_KBN を radioGroup1 の結果に合わせて更新する
                        // （initHaisouGiftData が再実行された場合に正しい状態を復元するため）
                        var newUPDChakubiKbn = newRadioGroup1 === 2 ? '1' : (newRadioGroup1 === 3 ? '2' : '');
                        _this.$set(dest, 'UPD_CHAKUBI_KBN', newUPDChakubiKbn);
                    }

                    // 希望時間のコピー(時間帯利用オプションが有効な場合)
                    if (_this.sh045Init.tdkTimeFlg == 1 && String(dest['TDK_HMS_DISP_FLG'] || '') == '1') {
                        // 必須/指定不可チェックを追加（PL/SQL: TDK_HSTM_ERR_FLG / TDK_HSTM_HISSU_FLG 相当）
                        var destHmsSetNgFlg = String(dest['TDK_HMS_SET_NG_FLG'] || '');
                        var destHstmHissuFlg = String((dest['TDK_ITEM_LIST'] && dest['TDK_ITEM_LIST'][0]) ? dest['TDK_ITEM_LIST'][0]['TDK_HSTM_HISSU_FLG'] || '' : '');
                        var canCopyTime = true;
                        var haisouLabel = dest['msgLabel'];
                        if (destHmsSetNgFlg == '1' && srcHasTime) {
                            canCopyTime = false;
                            copyErrMsgs.push(haisouLabel + 'お届け希望時間は指定不可です。');
                        } else if (destHstmHissuFlg == '1' && !srcHasTime) {
                            canCopyTime = false;
                            copyErrMsgs.push(haisouLabel + 'お届け希望時間は必須です。');
                        }
                        // コピー先プルダウンリストに存在しない時間帯はコピー不可
                        if (canCopyTime && srcHasTime && dest['hopeTimeList']) {
                            var foundTime = dest['hopeTimeList'].some(function(item) { return item.KEY == srcInfo['hopeTdkTimeKbn']; });
                            if (!foundTime) {
                                canCopyTime = false;
                                copyErrMsgs.push(haisouLabel + '指定できないお届け希望時間です。');
                            }
                        }
                        if (canCopyTime) {
                            _this.$set(dest, 'hopeTdkTimeKbn', srcInfo['hopeTdkTimeKbn'] || '');
                        }
                    }

                    // 同梱品フラグのコピー
                    // コピー元・コピー先双方が同梱品設定可の配送先の場合のみコピーする
                    if (_this.isDoukonHinAvailable(srcInfo) && _this.isDoukonHinAvailable(dest)) {
                        _this.$set(dest, 'doukonHinFlg', srcInfo['doukonHinFlg'] != null ? String(srcInfo['doukonHinFlg']) : '0');
                    }
                }
            }

            // コピー不可があった場合、エラーメッセージを表示する
            if (copyErrMsgs.length > 0) {
                _this.listMessValid = ['一部の配送ギフト設定が反映できませんでした。反映結果をご確認ください。'].concat(copyErrMsgs);
                common.scrollTop();
            }
        },

        getItemNoshiCd: function(list) {
            for (let i = 0; i < list.length; i++) {
                var noshiCd = list[i]['NOSHI_CD'];
                if (noshiCd && noshiCd.trim() !== '') {
                    return noshiCd;
                }
            }
            return '';
        },

        getItemNoshiNm: function(list) {
            for (let i = 0; i < list.length; i++) {
                var noshiNm = list[i]['NOSHI_NM'];
                if (noshiNm && noshiNm.trim() !== '') {
                    return noshiNm;
                }
            }
            return '設定なし';
        },

        getItemNaire: function(list) {
            for (let i = 0; i < list.length; i++) {
                var naireValue = list[i]['NAIRE'];
                if (naireValue && naireValue.trim() !== '') {
                    return naireValue;
                }
            }
            return '設定なし';
        },

        getErrImage(event) {
            event.target.src = common.getImgDefault();
        },
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;

        var paramData = _this.$route.params;

        this.$on("event-loading-message", (isLoading, message) => {
            this.isLoading = isLoading;
            this.loadingMessage = message;
        });

        if (_this.$route.query && _this.$route.query.pageNo) {
            _this.currPageNo = _this.$route.query.pageNo;
        }
        if (_this.$route.query && _this.$route.query.scrollId) {
            _this.scrollId = _this.$route.query.scrollId;
            _this.tdkSeq = _this.$route.query.tdkSeq;
        }
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0) {
            _this.sh060 = queryData;
        }
    },

    beforeDestroy() {
        EventBus.$off('evtClickOk');
    },


};
</script>
<style scoped>
#sh045 table tr td:nth-child(1):before {
    content: "" !important;
}
.sh045-txt-zaiko-warn {
    display: block;
}
.error-message-warn {
    display: block;
    color: red;
}
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 1000;
}

.loading-message {
    color: black;
    font-size: 2em;
}
.vld-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#sh045 #changeTdkDay {
  font-size: 15px;
  font-weight: normal;	
  color: #000;
  border: solid 1px #000;
  background: #f9f9f9;
  height: 32px;
  line-height: 32px;
  display: block;
  width: 80px;
  text-align: center;
  border-radius: 4px;
}
#sh045 #changeTdkGift {
  font-size: 15px;
  font-weight: normal;	
  color: #000;
  border: solid 1px #000;
  background: #f9f9f9;
  height: 32px;
  line-height: 32px;
  display: block;
  width: 80px;
  text-align: center;
  border-radius: 4px;
}
#sh045 #copyTdkGiftSetting {
  font-size: 15px;
  font-weight: normal;	
  color: #000;
  border: solid 1px #000;
  background: #f9f9f9;
  height: 32px;
  line-height: 32px;
  display: block;
  width: 320px;
  text-align: center;
  border-radius: 4px;
}
.sh045-item-img {
  display: block;
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 4px;
}
#sh045 .sh045-body-order-tbl-person th {
  white-space: nowrap;
}
</style>